// Table of Content
// =================
// Detect browser
// Detect mobile device
// Page transitions
// Smooth Scrollbar
// Magic cursor
// Image lazy loading
// Header tools
// Main menu (classic)
// Overlay menu
// tt-Search
// Portfolio slider (full screen slider)
// Portfolio carousel (full screen carousel)
// Content carousel
// Testimonials slider
// Isotope
// lightGallery (lightbox plugin)
// Page header
// GSAP ScrollTrigger plugin
// Portfolio list
// Portfolio interactive
// Portfolio grid
// tt-Gallery
// tt-Accordion
// tt-Tabs
// Page nav
// Sidebar
// Sliding sidebar
// Scrolling text
// Scroll between anchors
// Scroll to top
// Defer videos (Youtube, Vimeo)
// Forms
// Miscellaneous
//

// counterup

!function(t) {
    "use strict";
    t.fn.countUp = function(e) {
        var a = t.extend({
            time: 2e3,
            delay: 10
        }, e);
        return this.each(function() {
            var e = t(this)
              , n = a
              , u = function() {
                e.data("counterupTo") || e.data("counterupTo", e.text());
                var t = parseInt(e.data("counter-time")) > 0 ? parseInt(e.data("counter-time")) : n.time
                  , a = parseInt(e.data("counter-delay")) > 0 ? parseInt(e.data("counter-delay")) : n.delay
                  , u = t / a
                  , r = e.data("counterupTo")
                  , o = [r]
                  , c = /[0-9]+,[0-9]+/.test(r);
                r = r.replace(/,/g, "");
                for (var d = (/^[0-9]+$/.test(r),
                /^[0-9]+\.[0-9]+$/.test(r)), s = d ? (r.split(".")[1] || []).length : 0, i = u; i >= 1; i--) {
                    var p = parseInt(Math.round(r / u * i));
                    if (d && (p = parseFloat(r / u * i).toFixed(s)),
                    c)
                        for (; /(\d+)(\d{3})/.test(p.toString()); )
                            p = p.toString().replace(/(\d+)(\d{3})/, "$1,$2");
                    o.unshift(p)
                }
                e.data("counterup-nums", o),
                e.text("0");
                var f = function() {
                    e.text(e.data("counterup-nums").shift()),
                    e.data("counterup-nums").length ? setTimeout(e.data("counterup-func"), a) : (delete e.data("counterup-nums"),
                    e.data("counterup-nums", null),
                    e.data("counterup-func", null))
                };
                e.data("counterup-func", f),
                setTimeout(e.data("counterup-func"), a)
            };
            e.waypoint(u, {
                offset: "100%",
                triggerOnce: !0
            })
        })
    }
}(jQuery);

/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function() {
    "use strict";
    function t(o) {
        if (!o)
            throw new Error("No options passed to Waypoint constructor");
        if (!o.element)
            throw new Error("No element option passed to Waypoint constructor");
        if (!o.handler)
            throw new Error("No handler option passed to Waypoint constructor");
        this.key = "waypoint-" + e,
        this.options = t.Adapter.extend({}, t.defaults, o),
        this.element = this.options.element,
        this.adapter = new t.Adapter(this.element),
        this.callback = o.handler,
        this.axis = this.options.horizontal ? "horizontal" : "vertical",
        this.enabled = this.options.enabled,
        this.triggerPoint = null,
        this.group = t.Group.findOrCreate({
            name: this.options.group,
            axis: this.axis
        }),
        this.context = t.Context.findOrCreateByElement(this.options.context),
        t.offsetAliases[this.options.offset] && (this.options.offset = t.offsetAliases[this.options.offset]),
        this.group.add(this),
        this.context.add(this),
        i[this.key] = this,
        e += 1
    }
    var e = 0
      , i = {};
    t.prototype.queueTrigger = function(t) {
        this.group.queueTrigger(this, t)
    }
    ,
    t.prototype.trigger = function(t) {
        this.enabled && this.callback && this.callback.apply(this, t)
    }
    ,
    t.prototype.destroy = function() {
        this.context.remove(this),
        this.group.remove(this),
        delete i[this.key]
    }
    ,
    t.prototype.disable = function() {
        return this.enabled = !1,
        this
    }
    ,
    t.prototype.enable = function() {
        return this.context.refresh(),
        this.enabled = !0,
        this
    }
    ,
    t.prototype.next = function() {
        return this.group.next(this)
    }
    ,
    t.prototype.previous = function() {
        return this.group.previous(this)
    }
    ,
    t.invokeAll = function(t) {
        var e = [];
        for (var o in i)
            e.push(i[o]);
        for (var n = 0, r = e.length; r > n; n++)
            e[n][t]()
    }
    ,
    t.destroyAll = function() {
        t.invokeAll("destroy")
    }
    ,
    t.disableAll = function() {
        t.invokeAll("disable")
    }
    ,
    t.enableAll = function() {
        t.Context.refreshAll();
        for (var e in i)
            i[e].enabled = !0;
        return this
    }
    ,
    t.refreshAll = function() {
        t.Context.refreshAll()
    }
    ,
    t.viewportHeight = function() {
        return window.innerHeight || document.documentElement.clientHeight
    }
    ,
    t.viewportWidth = function() {
        return document.documentElement.clientWidth
    }
    ,
    t.adapters = [],
    t.defaults = {
        context: window,
        continuous: !0,
        enabled: !0,
        group: "default",
        horizontal: !1,
        offset: 0
    },
    t.offsetAliases = {
        "bottom-in-view": function() {
            return this.context.innerHeight() - this.adapter.outerHeight()
        },
        "right-in-view": function() {
            return this.context.innerWidth() - this.adapter.outerWidth()
        }
    },
    window.Waypoint = t
}(),
function() {
    "use strict";
    function t(t) {
        window.setTimeout(t, 1e3 / 60)
    }
    function e(t) {
        this.element = t,
        this.Adapter = n.Adapter,
        this.adapter = new this.Adapter(t),
        this.key = "waypoint-context-" + i,
        this.didScroll = !1,
        this.didResize = !1,
        this.oldScroll = {
            x: this.adapter.scrollLeft(),
            y: this.adapter.scrollTop()
        },
        this.waypoints = {
            vertical: {},
            horizontal: {}
        },
        t.waypointContextKey = this.key,
        o[t.waypointContextKey] = this,
        i += 1,
        n.windowContext || (n.windowContext = !0,
        n.windowContext = new e(window)),
        this.createThrottledScrollHandler(),
        this.createThrottledResizeHandler()
    }
    var i = 0
      , o = {}
      , n = window.Waypoint
      , r = window.onload;
    e.prototype.add = function(t) {
        var e = t.options.horizontal ? "horizontal" : "vertical";
        this.waypoints[e][t.key] = t,
        this.refresh()
    }
    ,
    e.prototype.checkEmpty = function() {
        var t = this.Adapter.isEmptyObject(this.waypoints.horizontal)
          , e = this.Adapter.isEmptyObject(this.waypoints.vertical)
          , i = this.element == this.element.window;
        t && e && !i && (this.adapter.off(".waypoints"),
        delete o[this.key])
    }
    ,
    e.prototype.createThrottledResizeHandler = function() {
        function t() {
            e.handleResize(),
            e.didResize = !1
        }
        var e = this;
        this.adapter.on("resize.waypoints", function() {
            e.didResize || (e.didResize = !0,
            n.requestAnimationFrame(t))
        })
    }
    ,
    e.prototype.createThrottledScrollHandler = function() {
        function t() {
            e.handleScroll(),
            e.didScroll = !1
        }
        var e = this;
        this.adapter.on("scroll.waypoints", function() {
            (!e.didScroll || n.isTouch) && (e.didScroll = !0,
            n.requestAnimationFrame(t))
        })
    }
    ,
    e.prototype.handleResize = function() {
        n.Context.refreshAll()
    }
    ,
    e.prototype.handleScroll = function() {
        var t = {}
          , e = {
            horizontal: {
                newScroll: this.adapter.scrollLeft(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left"
            },
            vertical: {
                newScroll: this.adapter.scrollTop(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up"
            }
        };
        for (var i in e) {
            var o = e[i]
              , n = o.newScroll > o.oldScroll
              , r = n ? o.forward : o.backward;
            for (var s in this.waypoints[i]) {
                var a = this.waypoints[i][s];
                if (null !== a.triggerPoint) {
                    var l = o.oldScroll < a.triggerPoint
                      , h = o.newScroll >= a.triggerPoint
                      , p = l && h
                      , u = !l && !h;
                    (p || u) && (a.queueTrigger(r),
                    t[a.group.id] = a.group)
                }
            }
        }
        for (var c in t)
            t[c].flushTriggers();
        this.oldScroll = {
            x: e.horizontal.newScroll,
            y: e.vertical.newScroll
        }
    }
    ,
    e.prototype.innerHeight = function() {
        return this.element == this.element.window ? n.viewportHeight() : this.adapter.innerHeight()
    }
    ,
    e.prototype.remove = function(t) {
        delete this.waypoints[t.axis][t.key],
        this.checkEmpty()
    }
    ,
    e.prototype.innerWidth = function() {
        return this.element == this.element.window ? n.viewportWidth() : this.adapter.innerWidth()
    }
    ,
    e.prototype.destroy = function() {
        var t = [];
        for (var e in this.waypoints)
            for (var i in this.waypoints[e])
                t.push(this.waypoints[e][i]);
        for (var o = 0, n = t.length; n > o; o++)
            t[o].destroy()
    }
    ,
    e.prototype.refresh = function() {
        var t, e = this.element == this.element.window, i = e ? void 0 : this.adapter.offset(), o = {};
        this.handleScroll(),
        t = {
            horizontal: {
                contextOffset: e ? 0 : i.left,
                contextScroll: e ? 0 : this.oldScroll.x,
                contextDimension: this.innerWidth(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left",
                offsetProp: "left"
            },
            vertical: {
                contextOffset: e ? 0 : i.top,
                contextScroll: e ? 0 : this.oldScroll.y,
                contextDimension: this.innerHeight(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up",
                offsetProp: "top"
            }
        };
        for (var r in t) {
            var s = t[r];
            for (var a in this.waypoints[r]) {
                var l, h, p, u, c, d = this.waypoints[r][a], f = d.options.offset, w = d.triggerPoint, y = 0, g = null == w;
                d.element !== d.element.window && (y = d.adapter.offset()[s.offsetProp]),
                "function" == typeof f ? f = f.apply(d) : "string" == typeof f && (f = parseFloat(f),
                d.options.offset.indexOf("%") > -1 && (f = Math.ceil(s.contextDimension * f / 100))),
                l = s.contextScroll - s.contextOffset,
                d.triggerPoint = Math.floor(y + l - f),
                h = w < s.oldScroll,
                p = d.triggerPoint >= s.oldScroll,
                u = h && p,
                c = !h && !p,
                !g && u ? (d.queueTrigger(s.backward),
                o[d.group.id] = d.group) : !g && c ? (d.queueTrigger(s.forward),
                o[d.group.id] = d.group) : g && s.oldScroll >= d.triggerPoint && (d.queueTrigger(s.forward),
                o[d.group.id] = d.group)
            }
        }
        return n.requestAnimationFrame(function() {
            for (var t in o)
                o[t].flushTriggers()
        }),
        this
    }
    ,
    e.findOrCreateByElement = function(t) {
        return e.findByElement(t) || new e(t)
    }
    ,
    e.refreshAll = function() {
        for (var t in o)
            o[t].refresh()
    }
    ,
    e.findByElement = function(t) {
        return o[t.waypointContextKey]
    }
    ,
    window.onload = function() {
        r && r(),
        e.refreshAll()
    }
    ,
    n.requestAnimationFrame = function(e) {
        var i = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || t;
        i.call(window, e)
    }
    ,
    n.Context = e
}(),
function() {
    "use strict";
    function t(t, e) {
        return t.triggerPoint - e.triggerPoint
    }
    function e(t, e) {
        return e.triggerPoint - t.triggerPoint
    }
    function i(t) {
        this.name = t.name,
        this.axis = t.axis,
        this.id = this.name + "-" + this.axis,
        this.waypoints = [],
        this.clearTriggerQueues(),
        o[this.axis][this.name] = this
    }
    var o = {
        vertical: {},
        horizontal: {}
    }
      , n = window.Waypoint;
    i.prototype.add = function(t) {
        this.waypoints.push(t)
    }
    ,
    i.prototype.clearTriggerQueues = function() {
        this.triggerQueues = {
            up: [],
            down: [],
            left: [],
            right: []
        }
    }
    ,
    i.prototype.flushTriggers = function() {
        for (var i in this.triggerQueues) {
            var o = this.triggerQueues[i]
              , n = "up" === i || "left" === i;
            o.sort(n ? e : t);
            for (var r = 0, s = o.length; s > r; r += 1) {
                var a = o[r];
                (a.options.continuous || r === o.length - 1) && a.trigger([i])
            }
        }
        this.clearTriggerQueues()
    }
    ,
    i.prototype.next = function(e) {
        this.waypoints.sort(t);
        var i = n.Adapter.inArray(e, this.waypoints)
          , o = i === this.waypoints.length - 1;
        return o ? null : this.waypoints[i + 1]
    }
    ,
    i.prototype.previous = function(e) {
        this.waypoints.sort(t);
        var i = n.Adapter.inArray(e, this.waypoints);
        return i ? this.waypoints[i - 1] : null
    }
    ,
    i.prototype.queueTrigger = function(t, e) {
        this.triggerQueues[e].push(t)
    }
    ,
    i.prototype.remove = function(t) {
        var e = n.Adapter.inArray(t, this.waypoints);
        e > -1 && this.waypoints.splice(e, 1)
    }
    ,
    i.prototype.first = function() {
        return this.waypoints[0]
    }
    ,
    i.prototype.last = function() {
        return this.waypoints[this.waypoints.length - 1]
    }
    ,
    i.findOrCreate = function(t) {
        return o[t.axis][t.name] || new i(t)
    }
    ,
    n.Group = i
}(),
function() {
    "use strict";
    function t(t) {
        this.$element = e(t)
    }
    var e = window.jQuery
      , i = window.Waypoint;
    e.each(["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"], function(e, i) {
        t.prototype[i] = function() {
            var t = Array.prototype.slice.call(arguments);
            return this.$element[i].apply(this.$element, t)
        }
    }),
    e.each(["extend", "inArray", "isEmptyObject"], function(i, o) {
        t[o] = e[o]
    }),
    i.adapters.push({
        name: "jquery",
        Adapter: t
    }),
    i.Adapter = t
}(),
function() {
    "use strict";
    function t(t) {
        return function() {
            var i = []
              , o = arguments[0];
            return t.isFunction(arguments[0]) && (o = t.extend({}, arguments[1]),
            o.handler = arguments[0]),
            this.each(function() {
                var n = t.extend({}, o, {
                    element: this
                });
                "string" == typeof n.context && (n.context = t(this).closest(n.context)[0]),
                i.push(new e(n))
            }),
            i
        }
    }
    var e = window.Waypoint;
    window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)),
    window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto))
}();




(function ($) {
	'use strict';



	// ========================================
	// Detect browser and add class to </body>
	// ========================================

	// Detect Firefox
	let firefoxAgent = navigator.userAgent.indexOf("Firefox") > -1;

	// Add class "is-firefox" to </body>
	if (firefoxAgent) {
		$("body").addClass("is-firefox");
	}
	$(window).on('load', function() {
		var h = $('.top-header').height();
		console.log(h)
		$("#content-wrap").css('margin-top', h);
	})
	
	$(document).ready(function() {
		
		if ($("#page-content").hasClass("ph-is-light")) {
			$("body").addClass("ph-bg-image-light-on");
			
		}

		if ($("#page-header").hasClass("ph-cap-black")) {
			$("body").addClass("ph-bg-image-light-on");
		}
	})



	// ==========================================================
	// Detect mobile device and add class "is-mobile" to </body>
	// ==========================================================

	// Detect mobile device (Do not remove!!!)
	var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Nokia|Opera Mini/i.test(navigator.userAgent) ? true : false;

	// Add class "is-mobile" to </body>
	if (isMobile) {
		$("body").addClass("is-mobile");
	}



	// =================
	// Page transitions
	// =================

	if ($("body").hasClass("tt-transition")) {

		// Wait until the whole page is loaded.
		// $(window).on("load", function () {
		// 	setTimeout(function () {
		// 		HideLoad(); // call out animations.
		// 	}, 0);
		// });
		$(document).ready(function() {
			setTimeout(function(){
				HideLoad(); // call out animations.
			}, 0);
		})

		// Transitions In (when "ptr-overlay" slides in).
		// =================
		function RevealLoad() {
			var tl_transitIn = gsap.timeline({
				defaults: {
					duration: 1,
					ease: Expo.easeInOut
				}
			});
			tl_transitIn.set("#page-transition", {
				autoAlpha: 1
			});
			tl_transitIn.to(".ptr-overlay", {
				scaleY: 1,
				transformOrigin: "center bottom"
			}, 0);
			tl_transitIn.to("#content-wrap", {
				y: -80,
				autoAlpha: 0
			}, 0);
			tl_transitIn.to("#tt-header", {
				y: -20,
				autoAlpha: 0
			}, 0);
			tl_transitIn.to(".ptr-preloader", {
				autoAlpha: 1
			}, 0.4);
		}

		// Transitions Out (when "ptr-overlay" slides out)
		// ================
		function HideLoad() {
			var tl_transitOut = gsap.timeline();
			tl_transitOut.to(".ptr-preloader", {
				duration: 1,
				autoAlpha: 0,
				ease: Expo.easeInOut
			});
			tl_transitOut.to(".ptr-overlay", {
				duration: 1,
				scaleY: 0,
				transformOrigin: "center top",
				ease: Expo.easeInOut
			}, 0.3);

			// tt-Header appear
			tl_transitOut.from("#tt-header", {
				duration: 1,
				y: 20,
				autoAlpha: 0,
				ease: Expo.easeInOut,
				clearProps: "all"
			}, 0.6);

			// Page header image appear
			if ($(".ph-image").length) {
				if ($("#page-header").hasClass("ph-bg-image")) {
					tl_transitOut.from(".ph-image img, .ph-video", {
						duration: 1.5,
						y: 80,
						autoAlpha: 0,
						stagger: 0.3,
						ease: Expo.easeOut,
						clearProps: "all"
					}, 0.8);
				} else {
					tl_transitOut.from(".ph-image", {
						duration: 1.5,
						y: 80,
						autoAlpha: 0,
						stagger: 0.3,
						ease: Expo.easeOut,
						clearProps: "all"
					}, 1.2);
				}
			}

			// Page header elements appear (elements with class "ph-appear")
			if ($(".ph-appear").length) {
				tl_transitOut.from(".ph-appear", {
					duration: 1.5,
					y: 60,
					autoAlpha: 0,
					stagger: 0.3,
					ease: Expo.easeOut,
					clearProps: "all"
				}, 1.5);
			}

			// Page header elements appear (project info list)
			if ($("#page-header .project-info-list").length) {
				if ($("#page-header").hasClass("ph-inline")) {
					tl_transitOut.from("#page-header .project-info-list > ul > li", {
						duration: 1.5,
						y: 80,
						autoAlpha: 0,
						stagger: 0.15,
						ease: Expo.easeOut,
						clearProps: "all"
					}, 2.2);
				} else {
					tl_transitOut.from("#page-header .project-info-list > ul", {
						duration: 1.5,
						y: 80,
						autoAlpha: 0,
						ease: Expo.easeOut,
						clearProps: "all"
					}, 2.2);
				}
			}

			// Portfolio slider elements appear (full heigth slider)
			if ($(".tt-psc-elem").length) {
				$(".tt-psc-elem").wrap('<div class="tt-ps-appear"></div>');
				tl_transitOut.from(".tt-ps-appear", {
					duration: 1.5,
					y: 80,
					autoAlpha: 0,
					stagger: 0.3,
					ease: Expo.easeOut,
					clearProps: "all"
				}, 1.4);
			}

			// Portfolio carousel elements appear
			if ($(".tt-pci-title").length) {
				tl_transitOut.from(".tt-pci-title", {
					duration: 1.5,
					x: 80,
					autoAlpha: 0,
					skewX: "-10deg",
					ease: Expo.easeOut,
					clearProps: "all"
				}, 1.4);
			}
			if ($(".tt-pci-category").length) {
				tl_transitOut.from(".tt-pci-category", {
					duration: 1.5,
					x: 80,
					autoAlpha: 0,
					ease: Expo.easeOut,
					clearProps: "all"
				}, 1.5);
			}

			// Page other elements appear
			tl_transitOut.from("#page-content", {
				duration: 1.5,
				autoAlpha: 0,
				y: 80,
				ease: Expo.easeOut,
				clearProps: "all"
			}, 0.8);
			tl_transitOut.set("#page-transition", {
				duration: 1,
				autoAlpha: 0,
				ease: Expo.easeInOut
			});
		}

		// Force page a reload when browser "Back" button click.
		// =====================================================
		window.onpageshow = function (event) {
			if (event.persisted) {
				window.location.reload();
			}
		}


		// On link click
		// ==============
		$("a")
			.not('[target="_blank"]') // omit from selection
			.not('[href^="#"]') // omit from selection
			.not('[href^="mailto"]') // omit from selection
			.not('[href^="tel"]') // omit from selection
			.not(".lg-trigger") // omit from selection
			.not(".tt-btn-disabled a") // omit from selection
			.not(".no-transition") // omit from selection
			.on('click', function (e) {
				e.preventDefault();

				setTimeout(function (url) {
					window.location = url
				}, 1000, this.href);

				RevealLoad(); // call in animations.
			});

	}



	// =======================================================================================
	// Smooth Scrollbar
	// Source: https://github.com/idiotWu/smooth-scrollbar/
	// =======================================================================================

	if ($("body").hasClass("tt-smooth-scroll")) {

		// Not for mobile devices!
		if (!isMobile) {

			// Init Smooth Scrollbar
			// ======================
			var Scrollbar = window.Scrollbar;
			Scrollbar.init(document.querySelector("#scroll-container"), {
				damping: 0.06,
				renderByPixel: true,
				continuousScrolling: true,
				alwaysShowTracks: true
			});


			// 3rd party library setup
			// More info: https://greensock.com/docs/v3/Plugins/ScrollTrigger/static.scrollerProxy()
			// ========================
			let scrollPositionX = 0,
				scrollPositionY = 0,
				bodyScrollBar = Scrollbar.init(document.getElementById("scroll-container"));

			bodyScrollBar.addListener(({
				offset
			}) => {
				scrollPositionX = offset.x;
				scrollPositionY = offset.y;
			});

			bodyScrollBar.setPosition(0, 0);
			bodyScrollBar.track.xAxis.element.remove();

			// tell ScrollTrigger to use these proxy getter/setter methods for the "body" element:
			ScrollTrigger.scrollerProxy("body", {
				scrollTop(value) {
					if (arguments.length) {
						bodyScrollBar.scrollTop = value;
					}
					return bodyScrollBar.scrollTop;
				}
			});

			ScrollTrigger.create({
				trigger: "#tt-header",
				start: 50,
				end: 99999,
				toggleClass: {
					className: 'scroll-menu',
					targets: '#tt-header'
				}
			})

			scrollpanel();
			/*--- Scroll Panel ---*/
			function scrollpanel() {
				const DOM = {
					sections: {
						columns: document.querySelector('.section--columns'),
						showcase: document.querySelector('.section--showcase'),
						startcase: document.querySelector('.section-1'),
					},
					columns: document.querySelectorAll('.section--columns > .columns'),
					columnWraps: document.querySelectorAll('.section--columns .column-wrap'),
					itemsWrappers: document.querySelectorAll('.section--columns .column-wrap .column'),
					items: document.querySelectorAll('.section--columns .column__item'),
					images: document.querySelectorAll('.section--columns .column__item-img'),
				};

				// Lenis smooth scrolling
				// let lenis;

				// Initialize Lenis smooth scrolling
				// const initSmoothScrolling = () => {
				// 	lenis = new Lenis({
				// 		lerp: 0.2,
				// 		smooth: true,
				// 	});
				// 	const scrollFn = (time) => {
				// 		lenis.raf(time);
				// 		requestAnimationFrame(scrollFn);
				// 	};
				// 	requestAnimationFrame(scrollFn);
				// };

				// GSAP Scroll Triggers
				const scroll = () => {
					gsap.timeline({
							scrollTrigger: {
								trigger: DOM.sections.startcase,
								start: '10px bottom',
								endTrigger: DOM.sections.showcase,
								scrub: true

							}
						})
						.addLabel('start', 0)
						.to(DOM.sections.columns, {
							scrollTrigger: {
								trigger: DOM.sections.startcase,
								start: '10px bottom',
								endTrigger: DOM.sections.showcase,
								scrub: true,
							},
							ease: 'none',
							startAt: {
								scale: 1.1
							},
							scale: 0.8,
						}, 'start')
						.to(DOM.sections.columns, {
							scrollTrigger: {
								trigger: DOM.sections.startcase,
								start: '10px bottom',
								eendTrigger: DOM.sections.showcase,
								scrub: true
							},
							ease: 'power4.inOut',
							startAt: {
								opacity: 0.1,
							},
							opacity: 1,
							// repeat once (go back to "startAt" values)
							yoyo: true,
							repeat: 1
						}, 'start')
						.to(DOM.columnWraps, {
							scrollTrigger: {
								trigger: DOM.sections.startcase,
								start: '10px bottom',
								endTrigger: DOM.sections.showcase,
								scrub: true,
							},
							ease: 'none',
							yPercent: pos => pos % 2 ? 10 : -10
						}, 'start')
				};
				// initSmoothScrolling();
				scroll();
			}

			// when smooth scroller updates, tell ScrollTrigger to update() too.
			bodyScrollBar.addListener(ScrollTrigger.update);


			// Move "tt-header" out of "scroll-container"
			// Expl: Since Smooth Scrollbar doesn't support element fixed position inside "scroll-container" move the "tt-header" out of it.
			// ==========================================
			if ($("#tt-header").hasClass("tt-header-fixed")) {
				$("#tt-header").prependTo($("#body-inner"));
			}


			// Enable regular scrollbar inside a smooth scrollbar (#scroll-container). IMPORTANT: use class "tt-overflow" on inside scroll elements!
			// ===================================================
			if ($(".tt-overflow").length) {
				// Determine if an element is scrollable
				$.fn.ttIsScrollable = function () {
					return this[0].scrollWidth > this[0].clientWidth || this[0].scrollHeight > this[0].clientHeight;
				};

				$(".tt-overflow").each(function () {
					var $this = $(this);
					if ($this.ttIsScrollable()) {
						$this.on("wheel", function (e) {
							e.stopPropagation();
						});
					}
				});
			}


			// Prevent input[type=number] to scroll on focus
			// ==============================================
			$("input[type=number]").on("focus", function () {
				$(this).on("wheel", function (e) {
					e.stopPropagation();
				});
			});

		} else {
			ScrollTrigger.create({
				trigger: "#tt-header",
				start: 50,
				end: 99999,
				toggleClass: {
					className: 'scroll-menu',
					targets: '#tt-header'
				}
			})
			$('.section-1').css('min-height', '900px')
			
			
			scrollpanel();
			/*--- Scroll Panel ---*/
			function scrollpanel() {
				const DOM = {
					sections: {
						columns: document.querySelector('.section--columns'),
						showcase: document.querySelector('.section--showcase'),
						startcase: document.querySelector('.section-1'),
					},
					columns: document.querySelectorAll('.section--columns > .columns'),
					columnWraps: document.querySelectorAll('.section--columns .column-wrap'),
					itemsWrappers: document.querySelectorAll('.section--columns .column-wrap .column'),
					items: document.querySelectorAll('.section--columns .column__item'),
					images: document.querySelectorAll('.section--columns .column__item-img'),
				};

				// Lenis smooth scrolling
				// let lenis;

				// Initialize Lenis smooth scrolling
				// const initSmoothScrolling = () => {
				// 	lenis = new Lenis({
				// 		lerp: 0.2,
				// 		smooth: true,
				// 	});
				// 	const scrollFn = (time) => {
				// 		lenis.raf(time);
				// 		requestAnimationFrame(scrollFn);
				// 	};
				// 	requestAnimationFrame(scrollFn);
				// };

				// GSAP Scroll Triggers
				const scroll = () => {
					gsap.timeline({
							scrollTrigger: {
								trigger: DOM.sections.startcase,
								start: '10px bottom',
								endTrigger: DOM.sections.showcase,
								scrub: true

							}
						})
						.addLabel('start', 0)
						.to(DOM.sections.columns, {
							scrollTrigger: {
								trigger: DOM.sections.startcase,
								start: '10px bottom',
								endTrigger: DOM.sections.showcase,
								scrub: true,
							},
							ease: 'none',
							startAt: {
								scale: 1.1
							},
							scale: 0.8,
						}, 'start')
						.to(DOM.sections.columns, {
							scrollTrigger: {
								trigger: DOM.sections.startcase,
								start: '10px bottom',
								eendTrigger: DOM.sections.showcase,
								scrub: true
							},
							ease: 'power4.inOut',
							startAt: {
								opacity: 0.1,
							},
							opacity: 1,
							// repeat once (go back to "startAt" values)
							yoyo: true,
							repeat: 1
						}, 'start')
						.to(DOM.columnWraps, {
							scrollTrigger: {
								trigger: DOM.sections.startcase,
								start: '10px bottom',
								endTrigger: DOM.sections.showcase,
								scrub: true,
							},
							ease: 'none',
							yPercent: pos => pos % 2 ? 3 : -3
						}, 'start')
				};
				// initSmoothScrolling();
				scroll();
			}
		}

	}
	else {
		$(document).ready(function ($) {
			$(window).scroll(function() {
				var scrollPosition = $(this).scrollTop();
				
				if (scrollPosition >= 50) {
					$('#tt-header').addClass('scroll-menu')
				}
				else {
					$('#tt-header').removeClass('scroll-menu')
				}
			});
		});
	}


	if ($("body").not(".is-mobile")) {
		gsap.timeline({
				scrollTrigger: {
					trigger: ".gallery-wrapper",
					// pin: true,
					start: "-200",
					end: "+=500",
					// markers: true,
					scrub: true,
					// yPercent: -200,
				}
			})
			.from(".gallery-item.el-4", {
				scale: 2,
				duration: 2,
				yPercent: -50,
				ease: "none",
				// stagger: { amount: 1 }
			})
			.from(".gallery-item.el-1", {
				yPercent: -50,
				opacity: 0,
				scale: 0,
				duration: 1,
				ease: "none",
				// stagger: { amount: 1 }
			}, "-=0.8")
			.from(".gallery-item.el-2", {
				xPercent: 50,
				opacity: 0,
				scale: 0,
				duration: 1,
				ease: "none",
				// stagger: { amount: 1 }
			}, "-=1")
			.from(".gallery-item.el-3", {
				xPercent: -50,
				opacity: 0,
				scale: 0,
				duration: 1,
				ease: "none",
				// stagger: { amount: 1 }
			}, "-=1")
			.from(".gallery-item.el-5", {
				yPercent: -100,
				opacity: 0,
				scale: 0,
				duration: 1,
				ease: "none",
				// stagger: { amount: 1 }
			}, "-=1")
			.to(".gallery-wrapper", {
				y: 400,
				opacity: 1,
				scale: 0.9,
				duration: 2,
				ease: "none",
			}, "-=1")
	}



	// =======================================================================================
	// Magic cursor (no effect on small screens!)
	// https://codepen.io/Sahil89/pen/MQbdNR
	// https://greensock.com/forums/topic/17490-follow-button-effect/?tab=comments#comment-81107
	// =======================================================================================

	if ($("body").not(".is-mobile").hasClass("tt-magic-cursor")) {
		if ($(window).width() > 1024) {
			$(".magnetic-item").wrap('<div class="magnetic-wrap"></div>');

			if ($("a.magnetic-item").length) {
				$("a.magnetic-item").addClass("not-hide-cursor");
			}

			var $mouse = {
				x: 0,
				y: 0
			}; // Cursor position
			var $pos = {
				x: 0,
				y: 0
			}; // Cursor position
			var $ratio = 0.15; // delay follow cursor
			var $active = false;
			var $ball = $("#ball");

			var $ballWidth = 34; // Ball default width
			var $ballHeight = 34; // Ball default height
			var $ballScale = 1; // Ball default scale
			var $ballOpacity = 0.5; // Ball default opacity
			var $ballBorderWidth = 2; // Ball default border width

			gsap.set($ball, { // scale from middle and style ball
				xPercent: -50,
				yPercent: -50,
				width: $ballWidth,
				height: $ballHeight,
				borderWidth: $ballBorderWidth,
				opacity: $ballOpacity
			});

			document.addEventListener("mousemove", mouseMove);

			function mouseMove(e) {
				$mouse.x = e.clientX;
				$mouse.y = e.clientY;
			}

			gsap.ticker.add(updatePosition);

			function updatePosition() {
				if (!$active) {
					$pos.x += ($mouse.x - $pos.x) * $ratio;
					$pos.y += ($mouse.y - $pos.y) * $ratio;

					gsap.set($ball, {
						x: $pos.x,
						y: $pos.y
					});
				}
			}

			$(".magnetic-wrap").mousemove(function (e) {
				parallaxCursor(e, this, 2); // magnetic ball = low number is more attractive
				callParallax(e, this);
			});

			function callParallax(e, parent) {
				parallaxIt(e, parent, parent.querySelector(".magnetic-item"), 25); // magnetic area = higher number is more attractive
			}

			function parallaxIt(e, parent, target, movement) {
				var boundingRect = parent.getBoundingClientRect();
				var relX = e.clientX - boundingRect.left;
				var relY = e.clientY - boundingRect.top;

				gsap.to(target, {
					duration: 0.3,
					x: ((relX - boundingRect.width / 2) / boundingRect.width) * movement,
					y: ((relY - boundingRect.height / 2) / boundingRect.height) * movement,
					ease: Power2.easeOut
				});
			}

			function parallaxCursor(e, parent, movement) {
				var rect = parent.getBoundingClientRect();
				var relX = e.clientX - rect.left;
				var relY = e.clientY - rect.top;
				$pos.x = rect.left + rect.width / 2 + (relX - rect.width / 2) / movement;
				$pos.y = rect.top + rect.height / 2 + (relY - rect.height / 2) / movement;
				gsap.to($ball, {
					duration: 0.3,
					x: $pos.x,
					y: $pos.y
				});
			}


			// Magic cursor behavior
			// ======================

			// Magnetic item hover.
			$(".magnetic-wrap").on("mouseenter", function (e) {
				gsap.to($ball, {
					duration: 0.3,
					scale: 2,
					borderWidth: 1,
					opacity: $ballOpacity
				});
				$active = true;
			}).on("mouseleave", function (e) {
				gsap.to($ball, {
					duration: 0.3,
					scale: $ballScale,
					borderWidth: $ballBorderWidth,
					opacity: $ballOpacity
				});
				gsap.to(this.querySelector(".magnetic-item"), {
					duration: 0.3,
					x: 0,
					y: 0,
					clearProps: "all"
				});
				$active = false;
			});

			// Alternative cursor style on hover.
			$(".cursor-alter, .tt-main-menu-list > li > a, .tt-main-menu-list > li > .tt-submenu-trigger > a")
				.not(".magnetic-item") // omit from selection.
				.on("mouseenter", function () {
					gsap.to($ball, {
						duration: 0.3,
						borderWidth: 0,
						opacity: 0.2,
						backgroundColor: "#333",
						width: "100px",
						height: "100px",
					});
				}).on("mouseleave", function () {
					gsap.to($ball, {
						duration: 0.3,
						borderWidth: $ballBorderWidth,
						opacity: $ballOpacity,
						backgroundColor: "transparent",
						width: $ballWidth,
						height: $ballHeight,
						clearProps: "backgroundColor"
					});
				});

			// Overlay menu caret hover.
			$(".tt-ol-submenu-caret-wrap .magnetic-wrap").on("mouseenter", function () {
				gsap.to($ball, {
					duration: 0.3,
					scale: 1.3,
					borderWidth: $ballBorderWidth
				});
			}).on("mouseleave", function () {
				gsap.to($ball, {
					duration: 0.3,
					scale: $ballScale
				});
			});

			// Cursor view on hover (data attribute "data-cursor="...").
			$("[data-cursor]").each(function () {
				$(this).on("mouseenter", function () {
					$ball.append('<div class="ball-view"></div>');
					$(".ball-view").append($(this).attr("data-cursor"));
					gsap.to(ball, {
						duration: 0.3,
						yPercent: -55,
						width: 80,
						height: 80,
						opacity: 1,
						borderWidth: 0,
						backgroundColor: "#333"
					});
					gsap.to(".ball-view", {
						duration: 0.3,
						scale: 1,
						autoAlpha: 1
					});
				}).on("mouseleave", function () {
					gsap.to(ball, {
						duration: 0.3,
						yPercent: -50,
						width: $ballWidth,
						height: $ballHeight,
						opacity: $ballOpacity,
						borderWidth: $ballBorderWidth,
						backgroundColor: "transparent"
					});
					gsap.to(".ball-view", {
						duration: 0.3,
						scale: 0,
						autoAlpha: 0,
						clearProps: "all"
					});
					$ball.find(".ball-view").remove();
				});
				$(this).addClass("not-hide-cursor");
			});

			// Cursor drag on hover (class "cursor-drag"). For Swiper sliders.
			$(".swiper").each(function () {
				if ($(this).parent().attr("data-simulate-touch") == "true") {
					if ($(this).parent().hasClass("cursor-drag")) {
						$(this).on("mouseenter", function () {
							$ball.append('<div class="ball-drag"></div>');
							gsap.to($ball, {
								duration: 0.3,
								width: 60,
								height: 60,
								opacity: 1
							});
						}).on("mouseleave", function () {
							$ball.find(".ball-drag").remove();
							gsap.to($ball, {
								duration: 0.3,
								width: $ballWidth,
								height: $ballHeight,
								opacity: $ballOpacity
							});
						});
						$(this).addClass("not-hide-cursor");

						// Ignore "data-cursor" on hover.
						$(this).find("[data-cursor]").on("mouseenter mouseover", function () {
							$ball.find(".ball-drag").remove();
							return false;
						}).on("mouseleave", function () {
							$ball.append('<div class="ball-drag"></div>');
							gsap.to($ball, {
								duration: 0.3,
								width: 60,
								height: 60,
								opacity: 1
							});
						});
					}
				}
			});

			// Cursor drag on mouse down / click and hold effect (class "cursor-drag-mouse-down"). For Swiper sliders.
			$(".swiper").each(function () {
				if ($(this).parent().attr("data-simulate-touch") == "true") {
					if ($(this).parent().hasClass("cursor-drag-mouse-down")) {
						$(this).on("mousedown pointerdown", function (e) {
							if (e.which === 1) { // Affects the left mouse button only!
								gsap.to($ball, {
									duration: 0.2,
									width: 60,
									height: 60,
									opacity: 1
								});
								$ball.append('<div class="ball-drag"></div>');
							}
						}).on("mouseup pointerup", function () {
							$ball.find(".ball-drag").remove();
							if ($(this).find("[data-cursor]:hover").length) {} else {
								gsap.to($ball, {
									duration: 0.2,
									width: $ballWidth,
									height: $ballHeight,
									opacity: $ballOpacity
								});
							}
						}).on("mouseleave", function () {
							$ball.find(".ball-drag").remove();
							gsap.to($ball, {
								duration: 0.2,
								width: $ballWidth,
								height: $ballHeight,
								opacity: $ballOpacity
							});
						});

						// Ignore "data-cursor" on mousedown.
						$(this).find("[data-cursor]").on("mousedown pointerdown", function () {
							return false;
						});

						// Ignore "data-cursor" on hover.
						$(this).find("[data-cursor]").on("mouseenter mouseover", function () {
							$ball.find(".ball-drag").remove();
							return false;
						});
					}
				}
			});

			// Cursor close on hover.
			$(".cursor-close").each(function () {
				$(this).on("mouseenter", function () {
					$ball.addClass("ball-close-enabled");
					$ball.append('<div class="ball-close">Close</div>');
					gsap.to($ball, {
						duration: 0.3,
						yPercent: -75,
						width: 80,
						height: 80,
						opacity: 1
					});
					gsap.from(".ball-close", {
						duration: 0.3,
						scale: 0,
						autoAlpha: 0
					});
				}).on("mouseleave click", function () {
					$ball.removeClass("ball-close-enabled");
					gsap.to($ball, {
						duration: 0.3,
						yPercent: -50,
						width: $ballWidth,
						height: $ballHeight,
						opacity: $ballOpacity
					});
					$ball.find(".ball-close").remove();
				});

				// Hover on "cursor-close" inner elements.
				$(".cursor-close a, .cursor-close button, .cursor-close .tt-btn, .cursor-close .hide-cursor")
					.not(".not-hide-cursor") // omit from selection (class "not-hide-cursor" is for global use).
					.on("mouseenter", function () {
						$ball.removeClass("ball-close-enabled");
					}).on("mouseleave", function () {
						$ball.addClass("ball-close-enabled");
					});
			});

			// Portfolio interactive title link hover.
			$(".portfolio-interactive-item").each(function () {
				var $piItem = $(this);
				if ($(this).find(".pi-item-image").length) {
					$piItem.find(".pi-item-title-link").on("mouseenter mouseover", function () {
						$("#magic-cursor").addClass("portfolio-interactive-hover-on");
						$piItem.find(".pi-item-image").appendTo($ball);
						gsap.to($ball, {
							duration: 0.3,
							width: "20vw",
							height: "20vw",
							opacity: 1
						});
						$ball.find(".pi-item-image video").each(function () {
							$(this).get(0).play();
						});
					}).on("mouseleave", function () {
						$("#magic-cursor").removeClass("portfolio-interactive-hover-on");
						$ball.find(".pi-item-image").appendTo($piItem);
						gsap.to($ball, {
							duration: 0.3,
							width: $ballWidth,
							height: $ballHeight,
							opacity: $ballOpacity
						});
						$piItem.find('.pi-item-image video').each(function () {
							$(this).get(0).pause();
						});
					});
					$(this).find(".pi-item-title-link").addClass("not-hide-cursor");
				}
			});

			// Blog interactive title link hover.
			$(".blog-interactive-item").each(function () {
				var $biItem = $(this);
				if ($biItem.find(".bi-item-image").length) {
					$biItem.find(".bi-item-title a").on("mouseenter mouseover", function () {
						$("#magic-cursor").addClass("blog-interactive-hover-on");
						$biItem.find(".bi-item-image").appendTo($ball);
						gsap.to($ball, {
							duration: 0.3,
							width: "20vw",
							height: "20vw",
							opacity: 1
						});
					}).on("mouseleave", function () {
						$("#magic-cursor").removeClass("blog-interactive-hover-on");
						$ball.find(".bi-item-image").appendTo($biItem);
						gsap.to($ball, {
							duration: 0.3,
							width: $ballWidth,
							height: $ballHeight,
							opacity: $ballOpacity
						});
					});
					$biItem.find(".bi-item-title a").addClass("not-hide-cursor");
					$biItem.addClass("bi-item-image-on");
				}
			});

			// Page nav hover.
			$(".tt-page-nav").each(function () {
				if ($(this).find(".tt-pn-image").length) {
					$(this).find(".tt-pn-link").on("mouseenter mouseover", function () {
						$("#magic-cursor").addClass("tt-pn-hover-on");
						$(this).parent().find(".tt-pn-image").appendTo($ball);
						gsap.to($ball, {
							duration: 0.3,
							width: "20vw",
							height: "20vw",
							opacity: 1
						});
						$ball.find(".tt-pn-image video").each(function () {
							$(this).get(0).play();
						});
					}).on("mouseleave", function () {
						$("#magic-cursor").removeClass("tt-pn-hover-on");
						$ball.find(".tt-pn-image").appendTo(this);
						gsap.to($ball, {
							duration: 0.3,
							width: $ballWidth,
							height: $ballHeight,
							opacity: $ballOpacity
						});

						$(this).parent().find('.tt-pn-image video').each(function () {
							$(this).get(0).pause();
						});
					});
					$(this).find(".tt-pn-link").addClass("not-hide-cursor");
				} else {
					$(this).find(".tt-pn-link").removeClass("not-hide-cursor");
				}
			});


			// Show/hide magic cursor
			// =======================

			// Hide on hover.
			$("a, button, .tt-btn, .tt-form-control, .tt-form-radio, .tt-form-check, .hide-cursor") // class "hide-cursor" is for global use.
				.not(".not-hide-cursor") // omit from selection (class "not-hide-cursor" is for global use).
				.not(".cursor-alter") // omit from selection
				.not(".tt-main-menu-list > li > a") // omit from selection
				.not(".tt-main-menu-list > li > .tt-submenu-trigger > a") // omit from selection
				.on("mouseenter", function () {
					gsap.to($ball, {
						duration: 0.3,
						scale: 0,
						opacity: 0
					});
				}).on("mouseleave", function () {
					gsap.to($ball, {
						duration: 0.3,
						scale: $ballScale,
						opacity: $ballOpacity
					});
				});

			// Hide on click.
			$("a")
				.not('[target="_blank"]') // omit from selection.
				.not('[href^="#"]') // omit from selection.
				.not('[href^="mailto"]') // omit from selection.
				.not('[href^="tel"]') // omit from selection.
				.not(".lg-trigger") // omit from selection.
				.not(".tt-btn-disabled a") // omit from selection.
				.on('click', function () {
					gsap.to($ball, {
						duration: 0.3,
						scale: 1.3,
						autoAlpha: 0
					});
				});

			// Show/hide on document leave/enter.
			$(document).on("mouseleave", function () {
				gsap.to("#magic-cursor", {
					duration: 0.3,
					autoAlpha: 0
				});
			}).on("mouseenter", function () {
				gsap.to("#magic-cursor", {
					duration: 0.3,
					autoAlpha: 1
				});
			});

			// Show as the mouse moves.
			$(document).mousemove(function () {
				gsap.to("#magic-cursor", {
					duration: 0.3,
					autoAlpha: 1
				});
			});
		}
	}



	// ==================================================
	// Image lazy loading
	// ==================================================

	ScrollTrigger.config({
		limitCallbacks: true
	});

	gsap.utils.toArray(".tt-lazy").forEach(image => {

		let newSRC = image.dataset.src,
			newImage = document.createElement("img"),

			loadImage = () => {
				newImage.onload = () => {
					newImage.onload = null; // avoid recursion
					newImage.src = image.src; // swap the src
					image.src = newSRC;
					// place the low-res version on TOP and then fade it out.
					gsap.set(newImage, {
						position: "absolute",
						top: image.offsetTop,
						left: image.offsetLeft,
						width: image.offsetWidth,
						height: image.offsetHeight
					});
					image.parentNode.appendChild(newImage);
					gsap.to(newImage, {
						opacity: 0,
						onComplete: () => {
							newImage.parentNode.removeChild(newImage);
							image.removeAttribute("data-src"); // remove "data-src" attribute if image is loaded
						}
					});
					st && st.kill();
				}
				newImage.src = newSRC;

				ScrollTrigger.refresh(true);
			},

			st = ScrollTrigger.create({
				trigger: image,
				start: "-50% bottom",
				onEnter: loadImage,
				onEnterBack: loadImage // make sure it works in either direction
			});
	});



	// ==================================
	// Header tools
	// ==================================

	// If tt-Header tools exist
	if ($(".tt-header-tools").length) {
		$("body").addClass("tt-header-tools-on");

		// Header tools dynamic
		// =====================
		if ($(".tt-header-tools-dynamic").length) {
			$("body").addClass("tt-header-tools-dynamic-on");

			// Move header tools dynamic out of header if the window width is 768px or smaller
			function headerToolsPosition() {
				if (window.matchMedia("(max-width: 768px)").matches) {
					$(".tt-header-tools-dynamic").prependTo("#body-inner");
					$(".tt-header-tools-dynamic").addClass("on-mobile");
				} else {
					$(".tt-header-tools-dynamic").prependTo(".tt-header-tools");
					$(".tt-header-tools-dynamic").removeClass("on-mobile");
				}
			}
			headerToolsPosition();
			$(window).resize(function () {
				headerToolsPosition();
			});
		}
	}



	// ==================================================
	// Main menu (classic)
	// ==================================================

	// Keeping sub-menus inside screen (useful if multi level sub-menus are used). Effect on large screens only!
	// More info: http://stackoverflow.com/questions/17985334/jquery-solution-for-keeping-dropdown-dropdown-inside-screen
	if ($(window).width() > 1200) {
		$(".tt-submenu-trigger").parent().on("mouseenter", function () {
			var menu = $("> .tt-submenu", this);
			var menupos = $(menu).offset();

			if (menupos.left + menu.width() > $(window).width()) {
				var newpos = -$(menu).width();

				menu.css({
					left: newpos
				});
			}
		});
	}

	// Main menu hover
	$(".tt-main-menu-list").on("mouseenter", function () {
		$(this).addClass("tt-mm-hover");
	}).on("mouseleave", function () {
		$(this).removeClass("tt-mm-hover");
	});

	// Submenu wrap hover
	$(".tt-submenu-wrap").on("mouseenter", function () {
		$(this).addClass("tt-submenu-open");
	}).on("mouseleave", function () {
		$(this).removeClass("tt-submenu-open");
	});


	// Mobile menu (for classic menu)
	// ===============================

	// Open/close mobile menu on toggle button click
	$("#tt-m-menu-toggle-btn-wrap").on("click", function () {
		$("html").toggleClass("tt-no-scroll");
		$("body").toggleClass("tt-m-menu-open");
		if ($("body").hasClass("tt-m-menu-open")) {

			// Menu step in animations
			$("body").addClass("tt-m-menu-toggle-no-click"); // Disable toggle button click until the animations last.

			// Menu in animations
			var tl_MenuIn = gsap.timeline({
				onComplete: function () {
					$("body").removeClass("tt-m-menu-toggle-no-click");
				}
			});

			tl_MenuIn.to(".tt-main-menu", {
				duration: 0.4,
				autoAlpha: 1
			});
			tl_MenuIn.from(".tt-main-menu-content > ul > li", {
				duration: 0.4,
				y: 80,
				autoAlpha: 0,
				stagger: 0.05,
				ease: Power2.easeOut,
				clearProps: "all"
			});

			// On menu link click
			$(".tt-main-menu a, .tt-logo a")
				.not('[target="_blank"]') // omit from selection
				.not('[href^="#"]') // omit from selection
				.not('[href^="mailto"]') // omit from selection
				.not('[href^="tel"]') // omit from selection
				.on('click', function () {
					gsap.set("#content-wrap", {
						autoAlpha: 0
					});
					gsap.to(".tt-main-menu-content > ul > li", {
						duration: 0.4,
						y: -80,
						autoAlpha: 0,
						stagger: 0.05,
						ease: Power2.easeIn
					});
				});

		} else {

			// Menu step out animations
			$("body").addClass("tt-m-menu-toggle-no-click"); // Disable toggle button click until the animations last.

			// Menu out animations
			var tl_MenuOut = gsap.timeline({
				onComplete: function () {
					$("body").removeClass("tt-m-menu-toggle-no-click");
				}
			});

			tl_MenuOut.to(".tt-main-menu-content > ul > li", {
				duration: 0.4,
				y: -80,
				autoAlpha: 0,
				stagger: 0.05,
				ease: Power2.easeIn
			});
			tl_MenuOut.to(".tt-main-menu", {
				duration: 0.4,
				autoAlpha: 0,
				clearProps: "all"
			}, "+=0.2");
			tl_MenuOut.to(".tt-main-menu-content > ul > li", {
				clearProps: "all"
			}); // clearProps only

			// Close open submenus
			setTimeout(function () {
				$(".tt-submenu").slideUp(350);
				$(".tt-submenu-trigger").removeClass("tt-m-submenu-open");
			}, 500);
		}

		return false;
	});

	// Append element if link href contains #
	$('.tt-submenu-trigger > a[href^="#"]').parent(".tt-submenu-trigger").append('<span class="tt-submenu-trigger-m"></span>');

	// Open submenu if link href contains #
	if ($(".tt-submenu-trigger > a").is('[href^="#"]')) {
		$(".tt-submenu-trigger-m").on("click", function () {
			var $this = $(this).parent();
			if ($this.hasClass("tt-m-submenu-open")) {
				$this.removeClass("tt-m-submenu-open");
				$this.next().slideUp(350);
			} else {
				$this.parent().parent().find(".tt-submenu").prev().removeClass("tt-m-submenu-open");
				$this.parent().parent().find(".tt-submenu").slideUp(350);
				$this.toggleClass("tt-m-submenu-open");
				$this.next().slideToggle(350);
			}
		});
	}

	// Open submenu on caret click
	$(".tt-submenu-trigger").append('<span class="tt-m-caret"></span>');
	$(".tt-m-caret").on("click", function () {
		var $this = $(this).parent();
		if ($this.hasClass("tt-m-submenu-open")) {
			$this.removeClass("tt-m-submenu-open");
			$this.next().slideUp(350);
		} else {
			$this.parent().parent().find(".tt-submenu").prev().removeClass("tt-m-submenu-open");
			$this.parent().parent().find(".tt-submenu").slideUp(350);
			$this.toggleClass("tt-m-submenu-open");
			$this.next().slideToggle(350);
		}
	});



	// ==================================================
	// Overlay menu
	// ==================================================

	// Add class "tt-header-fixed-on" to <body> if "tt-header-fixed" enabled.
	if ($("#tt-header").hasClass("tt-header-fixed")) {
		$("body").addClass("tt-header-fixed-on");
	}

	// On menu toggle button click
	// ============================
	var $olMenuToggleBtn = $(".tt-ol-menu-toggle-btn-text, .tt-ol-menu-toggle-btn");

	$olMenuToggleBtn.on("click", function () {
		$("html").toggleClass("tt-no-scroll");
		$("body").toggleClass("tt-ol-menu-open");
		if ($("body").hasClass("tt-ol-menu-open")) {

			// Menu step in animations
			// ========================
			$("body").addClass("olm-toggle-no-click"); // Disable toggle button click until the animations last.

			var tl_olMenuIn = gsap.timeline({
				onComplete: function () {
					$("body").removeClass("olm-toggle-no-click");
				}
			});

			tl_olMenuIn.to(".tt-overlay-menu", {
				duration: 0.4,
				autoAlpha: 1
			});
			tl_olMenuIn.from(".tt-ol-menu-list > li", {
				duration: 0.4,
				y: 80,
				autoAlpha: 0,
				stagger: 0.05,
				ease: Power2.easeOut,
				clearProps: "all"
			});

			// On menu link click
			$(".tt-overlay-menu a, .tt-logo a")
				.not('[target="_blank"]') // omit from selection
				.not('[href^="#"]') // omit from selection
				.not('[href^="mailto"]') // omit from selection
				.not('[href^="tel"]') // omit from selection
				.on('click', function () {
					gsap.set("#content-wrap, .ttgr-cat-nav", {
						autoAlpha: 0
					}); // Hide before timeline
					var tl_olMenuClick = gsap.timeline();
					tl_olMenuClick.to(".tt-ol-menu-list > li", {
						duration: 0.4,
						y: -80,
						autoAlpha: 0,
						stagger: 0.05,
						ease: Power2.easeIn
					});
				});

			// Hide sliding sidebar
			if ($(".tt-sliding-sidebar-wrap").length) {
				gsap.to(".tt-sliding-sidebar-trigger", {
					duration: 1,
					autoAlpha: 0,
					ease: Expo.easeOut
				});
			}

		} else {

			// Menu step out animations
			// =========================
			$("body").addClass("olm-toggle-no-click"); // Disable toggle button click until the animations last.

			var tl_olMenuOut = gsap.timeline({
				onComplete: function () {
					$("body").removeClass("olm-toggle-no-click");
				}
			});
			tl_olMenuOut.to(".tt-ol-menu-list > li", {
				duration: 0.4,
				y: -80,
				autoAlpha: 0,
				stagger: 0.05,
				ease: Power2.easeIn
			});
			tl_olMenuOut.to(".tt-overlay-menu", {
				duration: 0.4,
				autoAlpha: 0,
				clearProps: "all"
			}, "+=0.2");
			tl_olMenuOut.set(".tt-ol-menu-list > li", {
				clearProps: "all"
			}); // clearProps only

			// Show sliding sidebar
			if ($(".tt-sliding-sidebar-wrap").length) {
				gsap.to(".tt-sliding-sidebar-trigger", {
					duration: 1,
					autoAlpha: 1,
					ease: Expo.easeOut,
					clearProps: "all"
				}, "-=0.3");
			}

			// Close open submenus
			setTimeout(function () {
				$(".tt-ol-submenu").slideUp(350);
				$(".tt-ol-submenu-trigger").removeClass("tt-ol-submenu-open");
			}, 500);

		}

		return false;
	});

	// Menu list hover
	$(".tt-ol-menu-list").on("mouseenter", function () {
		$(this).addClass("tt-ol-menu-hover");
	}).on("mouseleave", function () {
		$(this).removeClass("tt-ol-menu-hover");
	});

	// Open submenu if link href contains #
	$(".tt-ol-submenu-trigger > a").on("click", function () {
		if ($(this).is('[href^="#"]')) {
			var $this = $(this).parent();
			if ($this.hasClass("tt-ol-submenu-open")) {
				$this.removeClass("tt-ol-submenu-open");
				$this.next().slideUp(350);
			} else {
				$this.parent().parent().find(".tt-ol-submenu").prev().removeClass("tt-ol-submenu-open");
				$this.parent().parent().find(".tt-ol-submenu").slideUp(350);
				$this.toggleClass("tt-ol-submenu-open");
				$this.next().slideToggle(350);
			}
		}
		return false;
	});

	// Open submenu on caret click
	$(".tt-ol-submenu-caret-wrap").on("click", function () {
		var $this = $(this).parent();
		if ($this.hasClass("tt-ol-submenu-open")) {
			$this.removeClass("tt-ol-submenu-open");
			$this.next().slideUp(350);
		} else {
			$this.parent().parent().find(".tt-ol-submenu").prev().removeClass("tt-ol-submenu-open");
			$this.parent().parent().find(".tt-ol-submenu").slideUp(350);
			$this.toggleClass("tt-ol-submenu-open");
			$this.next().slideToggle(350);
		}
	});



	// ==================================
	// tt-Search
	// ==================================

	if ($(".tt-search").length) {

		// Append tt-Search
		$(".tt-search").appendTo("#body-inner");

		// Open tt-Search
		$(".tt-search-trigger").on("click", function () {
			$("body").addClass("tt-search-open");
			var tl_ttSearchIn = gsap.timeline();
			tl_ttSearchIn.to(".tt-search", {
				duration: 0.4,
				autoAlpha: 1
			});
			tl_ttSearchIn.from(".tt-search-appear", {
				duration: 0.5,
				y: 80,
				autoAlpha: 0,
				stagger: 0.1,
				ease: Power2.easeOut,
				clearProps: "all"
			}, "+=0.1");
		});

		// Close tt-Search
		$(".tt-search-close, .tt-search-close-btn").on("click", function () {
			$("body").removeClass("tt-search-open");
			var tl_ttSearchOut = gsap.timeline();
			tl_ttSearchOut.to(".tt-search-appear", {
				duration: 0.5,
				y: -80,
				autoAlpha: 0,
				stagger: 0.05,
				ease: Power2.easeIn
			});
			tl_ttSearchOut.to(".tt-search", {
				duration: 0.4,
				autoAlpha: 0,
				clearProps: "all"
			}, "+=0.2");
			tl_ttSearchOut.to(".tt-search-appear", {
				clearProps: "all"
			});
		});
	}



	// =======================================================================================
	// Portfolio slider (full screen slider)
	// Source: https://swiperjs.com/
	// =======================================================================================

	if ($(".tt-portfolio-slider").length) {
		$(".tt-portfolio-slider").each(function () {
			var $ttPortfolioSlider = $(this);

			// Data attributes
			// ================
			var $dataMousewheel = $ttPortfolioSlider.data("mousewheel");
			var $dataKeyboard = $ttPortfolioSlider.data("keyboard");
			var $dataSimulateTouch = $ttPortfolioSlider.data("simulate-touch");
			var $dataGrabCursor = $ttPortfolioSlider.data("grab-cursor");
			var $dataAutoplay = $ttPortfolioSlider.data("autoplay") ? {
				delay: $ttPortfolioSlider.data("autoplay"),
			} : $ttPortfolioSlider.data("autoplay");
			var $dataLoop = $ttPortfolioSlider.data("loop") ? {
				loopedSlides: 100,
			} : $ttPortfolioSlider.data("loop"); // Not recommended!

			if ($ttPortfolioSlider.is("[data-speed]")) {
				var $dataSpeed = $ttPortfolioSlider.data("speed");
			} else {
				var $dataSpeed = 900; // by default
			}

			if ($ttPortfolioSlider.is("[data-pagination-type]")) {
				var $dataPaginationType = $ttPortfolioSlider.data("pagination-type");
			} else {
				var $dataPaginationType = "fraction"; // by default (bullets/fraction/progressbar)
			}

			// Init Swiper
			// =============
			var $ttPortfolioSliderSwiper = new Swiper($ttPortfolioSlider.find(".swiper")[0], {
				// Parameters
				direction: "horizontal",
				effect: "slide",
				speed: 600, // slider speed for smaller screens (when window width is 1024px or smaller)
				parallax: true,
				resistanceRatio: 0,
				longSwipesRatio: 0.02,
				preloadImages: false, // Needed for lazy loading
				preventInteractionOnTransition: true, // No actions during transition
				// autoplay: $dataAutoplay,
				mousewheel: $dataMousewheel,
				keyboard: $dataKeyboard,
				simulateTouch: $dataSimulateTouch,
				grabCursor: $dataGrabCursor,
				loop: $dataLoop, // Not recommended!
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
				breakpoints: {
					// when window width is 1025px or larger
					1025: {
						speed: $dataSpeed,
					}
				},

				// Lazy loading
				lazy: {
					loadPrevNext: true,
					loadOnTransitionStart: true,
				},

				// Navigation arrows
				navigation: {
					nextEl: $ttPortfolioSlider.find(".tt-ps-nav-arrow-next")[0],
					prevEl: $ttPortfolioSlider.find(".tt-ps-nav-arrow-prev")[0],
					disabledClass: "tt-ps-nav-arrow-disabled",
				},

				// Pagination
				pagination: {
					el: $ttPortfolioSlider.find(".tt-ps-nav-pagination")[0],
					type: $dataPaginationType,
					modifierClass: "tt-ps-nav-pagination-",
					dynamicBullets: true,
					dynamicMainBullets: 1,
					clickable: true,
				},

				// Events
				on: {
					init: function () {

						var $this = this;
						var $slideActive = $($this.slides[$this.activeIndex]);

						// Play video on load
						$slideActive.find("video").each(function () {
							$(this).get(0).play();
						});

						// Portfolio slider caption on load
						// ---------------------------------
						// Portfolio slider caption title (if contains link or not)
						if ($ttPortfolioSlider.find(".tt-ps-caption-title").length) {
							$ttPortfolioSlider.find(".tt-ps-caption-title").text($slideActive.attr("data-title"));
							$ttPortfolioSlider.find(".tt-ps-caption-title a").attr("href", $slideActive.attr("data-url"));
							$ttPortfolioSlider.find(".btn-group a").attr("href", $slideActive.attr("data-url"));
							$ttPortfolioSlider.find(".tt-ps-caption-title").attr("data-t", $slideActive.attr("data-title"));
						} else {
							$ttPortfolioSlider.find(".tt-ps-caption-title").text($slideActive.attr("data-title"));
							$ttPortfolioSlider.find(".btn-group a").attr("href", $slideActive.attr("data-url"));
							$ttPortfolioSlider.find(".tt-ps-caption-title").attr("data-t", $slideActive.attr("data-title"));
						}

						// Portfolio slider caption category on load
						$ttPortfolioSlider.find(".tt-ps-caption-category").text($slideActive.attr("data-category"));

						// If slider image is light on load
						setTimeout(function () {
							if ($slideActive.hasClass("psi-image-is-light")) {
								$("body").addClass("psi-light-image-on");
							} else {
								$("body").removeClass("psi-light-image-on");
							}
						}, 400);
					},

					transitionStart: function () {

						var $this = this;
						var $slideActive = $($this.slides[$this.activeIndex]);

						// If slider image is light
						setTimeout(function () {
							if ($slideActive.hasClass("psi-image-is-light")) {
								$("body").addClass("psi-light-image-on");
							} else {
								$("body").removeClass("psi-light-image-on");
							}
						}, 400);

						// Play video
						$slideActive.find("video").each(function () {
							$(this).get(0).play();
						});

						// Animate portfolio slider caption
						gsap.fromTo($ttPortfolioSlider.find(".tt-psc-elem"), {
							autoAlpha: 1,
							y: 0
						}, {
							duration: 0.25,
							autoAlpha: 0,
							y: -30,
							stagger: 0.15,
							ease: Power1.easeIn
						});
					},

					transitionEnd: function () {

						var $this = this;
						var $slideActive = $($this.slides[$this.activeIndex]);

						// Pause video
						$slideActive.prevAll().find("video").each(function () {
							$(this).get(0).pause();
						});
						$slideActive.nextAll().find("video").each(function () {
							$(this).get(0).pause();
						});

						// Portfolio slider caption
						// -------------------------
						// Portfolio slider caption title (if contains link or not)
						if ($ttPortfolioSlider.find(".tt-ps-caption-title").find("a").length) {
							$ttPortfolioSlider.find(".tt-ps-caption-title").text($slideActive.attr("data-title"));
							$ttPortfolioSlider.find(".tt-ps-caption-title a").attr("href", $slideActive.attr("data-url"));
							$ttPortfolioSlider.find(".btn-group a").attr("href", $slideActive.attr("data-url"));
							$ttPortfolioSlider.find(".tt-ps-caption-title").attr("data-t", $slideActive.attr("data-title"));
						} else {
							$ttPortfolioSlider.find(".tt-ps-caption-title").text($slideActive.attr("data-title"));
							$ttPortfolioSlider.find(".btn-group a").attr("href", $slideActive.attr("data-url"));
							$ttPortfolioSlider.find(".tt-ps-caption-title").attr("data-t", $slideActive.attr("data-title"));
						}

						// Portfolio slider caption category
						$ttPortfolioSlider.find(".tt-ps-caption-category").text($slideActive.attr("data-category"));

						// Animate portfolio slider caption
						gsap.fromTo($ttPortfolioSlider.find(".tt-psc-elem"), {
							autoAlpha: 0,
							y: 30
						}, {
							duration: 0.25,
							autoAlpha: 1,
							y: 0,
							stagger: 0.15,
							ease: Power1.easeOut
						});
					}
				}
			});


			// Parallax effect on mouse move (no effect on mobile devices!)
			// ------------------------------
			if (!isMobile) {
				if ($ttPortfolioSlider.data("parallax-mouse-move")) {
					gsap.set($ttPortfolioSlider.find(".tt-psi-image"), {
						scale: 1.05
					});

					$ttPortfolioSlider.mousemove(function (e) {
						parallaxIt(e, $ttPortfolioSlider.find(".tt-psi-image"), -25); // Parallax element
						parallaxIt(e, $ttPortfolioSlider.find(".tt-ps-caption-inner"), -35); // Parallax element
					});

					function parallaxIt(e, target, movement) {
						var $this = $ttPortfolioSlider
						var relX = e.pageX - $this.offset().left;
						var relY = e.pageY - $this.offset().top;

						gsap.to(target, {
							duration: 1,
							x: (relX - $this.width() / 2) / $this.width() * movement,
							y: (relY - $this.height() / 2) / $this.height() * movement
						});
					}
				}
			}

		});
	}



	// =======================================================================================
	// Portfolio carousel (full screen carousel)
	// Source: https://swiperjs.com/
	// =======================================================================================

	if ($(".tt-portfolio-carousel").length) {
		$(".tt-portfolio-carousel").each(function () {
			var $ttPortfolioCarousel = $(this);

			// Data attributes
			// ================
			var $dataMousewheel = $ttPortfolioCarousel.data("mousewheel");
			var $dataKeyboard = $ttPortfolioCarousel.data("keyboard");
			var $dataSimulateTouch = $ttPortfolioCarousel.data("simulate-touch");
			var $dataGrabCursor = $ttPortfolioCarousel.data("grab-cursor");
			var $dataAutoplay = $ttPortfolioCarousel.data("autoplay") ? {
				delay: $ttPortfolioCarousel.data("autoplay"),
			} : $ttPortfolioCarousel.data("autoplay");
			var $dataLoop = $ttPortfolioCarousel.data("loop") ? {
				loopedSlides: 100,
			} : $ttPortfolioCarousel.data("loop"); // Not recommended!

			if ($ttPortfolioCarousel.is("[data-speed]")) {
				var $dataSpeed = $ttPortfolioCarousel.data("speed"); // speed for larger screens
			} else {
				var $dataSpeed = 1200; // speed for larger screens (by default)
			}

			if ($ttPortfolioCarousel.is("[data-pagination-type]")) {
				var $dataPaginationType = $ttPortfolioCarousel.data("pagination-type");
			} else {
				var $dataPaginationType = "fraction"; // by default (bullets/fraction/progressbar)
			}

			// Init Swiper
			// =============
			var $ttPortfolioCarouselSwiper = new Swiper($ttPortfolioCarousel.find(".swiper")[0], {
				// Parameters
				direction: "horizontal",
				slidesPerView: "auto",
				spaceBetween: 0,
				resistanceRatio: 0.85,
				longSwipesRatio: 0.3,
				shortSwipes: true,
				centeredSlides: true,
				preloadImages: false, // Needed for lazy loading
				watchSlidesProgress: true, // Needed for lazy loading (if slidesPerView is "auto" or more than 1)
				preventInteractionOnTransition: false, // No actions during transition
				speed: 900, // Slider speed for smaller screens (when window width is 1024px or smaller)
				keyboard: $dataKeyboard,
				mousewheel: $dataMousewheel,
				autoplay: $dataAutoplay,
				simulateTouch: $dataSimulateTouch,
				grabCursor: $dataGrabCursor,
				loop: $dataLoop, // Not recommended!

				lazy: {
					loadPrevNext: true,
					loadOnTransitionStart: true,
				},

				breakpoints: {
					// When window width is 1025px or larger
					1025: {
						speed: $dataSpeed,
						lazy: {
							loadPrevNextAmount: 3, // Amount of next/prev slides to preload lazy images in.
						},
					}
				},

				// Navigation arrows
				navigation: {
					nextEl: $ttPortfolioCarousel.find(".tt-pc-arrow-next")[0],
					prevEl: $ttPortfolioCarousel.find(".tt-pc-arrow-prev")[0],
					disabledClass: "tt-pc-arrow-disabled",
				},

				// Pagination
				pagination: {
					el: $ttPortfolioCarousel.find(".tt-pc-pagination")[0],
					type: $dataPaginationType,
					modifierClass: "tt-pc-pagination-",
					dynamicBullets: true,
					dynamicMainBullets: 1,
					clickable: true,
				},

				// Events
				on: {
					lazyImageReady: (swiper) => { // Lazy load + slidesPerView:"auto" fix.
						$ttPortfolioCarouselSwiper.update()
					},

					init: function () {

						var $this = this;
						var $slideActive = $($this.slides[$this.activeIndex]);

						// Active slide class (custom) on load
						$slideActive.addClass("tt-slide-active"); // Add class to active slide.

						// Carousel slide disabled (prev/next slide) on load
						$slideActive.prevAll().addClass("tt-pcs-disabled");
						$slideActive.nextAll().addClass("tt-pcs-disabled");

					},

					transitionStart: function () {

						var $this = this;
						var $slideActive = $($this.slides[$this.activeIndex]);

						// Active slide classes (custom).
						$slideActive.addClass("tt-slide-active"); // Add class to active slide.
						$slideActive.prev().addClass("tt-slide-active-start"); // Add class if active slide transition starts.
						$slideActive.next().addClass("tt-slide-active-start"); // Add class if active slide transition starts.

						// Carousel slide disabled (prev/next slide)
						$slideActive.prevAll().addClass("tt-pcs-disabled");
						$slideActive.removeClass("tt-pcs-disabled");
						$slideActive.nextAll().addClass("tt-pcs-disabled");

						// Play video
						$(".swiper-slide-active").find("video").each(function () {
							$(this).get(0).play();
						});

						// Disable nav arrow action.
						$(".tt-pc-arrow").addClass("tt-pc-arrow-disabled");

					},

					transitionEnd: function () {

						var $this = this;
						var $slideActive = $($this.slides[$this.activeIndex]);

						// Active slide classes (custom)
						$slideActive.prevAll().removeClass("tt-slide-active"); // Remove class if active slide transition ends.
						$slideActive.nextAll().removeClass("tt-slide-active"); // Remove class if active slide transition ends.
						$slideActive.prev().removeClass("tt-slide-active-start"); // Remove class if active slide transition ends.
						$slideActive.next().removeClass("tt-slide-active-start"); // Remove class if active slide transition ends.

						// Pause video
						$(".swiper-slide-prev").find("video").each(function () {
							$(this).get(0).pause();
						});

						$(".swiper-slide-next").find("video").each(function () {
							$(this).get(0).pause();
						});

						// Disable nav arrow action.
						$(".tt-pc-arrow").removeClass("tt-pc-arrow-disabled");

					}
				}
			});

			// Scale down animation on carousel click
			if ($ttPortfolioCarousel.attr("data-simulate-touch") == "true") {
				if ($ttPortfolioCarousel.hasClass("pc-scale-down")) {
					$ttPortfolioCarousel.find(".swiper").on("mousedown touchstart pointerdown", function (e) {
						if (e.which === 1) { // Affects the left mouse button only!
							gsap.to($ttPortfolioCarousel.find(".swiper-slide"), {
								duration: 0.7,
								scale: 0.9
							});
						}
					});
					$("body").on("mouseup touchend pointerup mouseleave", function () {
						gsap.to($ttPortfolioCarousel.find(".swiper-slide"), {
							duration: 0.7,
							scale: 1,
							clearProps: "scale"
						});
					});
				}
			}

			// Update slider when windows resize or orientation change
			$(window).on("resize orientationchange", function () {
				setTimeout(function () {
					$ttPortfolioCarouselSwiper.update();
					$ttPortfolioCarousel.find(".swiper-wrapper").addClass("swtr-smooth");
				}, $dataSpeed);

				setTimeout(function () {
					$ttPortfolioCarousel.find(".swiper-wrapper").removeClass("swtr-smooth");
				}, $dataSpeed + $dataSpeed);
			});
		});
	}



	// =======================================================================================
	// Content carousel
	// Source: https://swiperjs.com/
	// =======================================================================================

	if ($(".tt-content-carousel").length) {
		$(".tt-content-carousel").each(function () {
			var $ttContentCarousel = $(this);

			// Data attributes
			// ================
			var $dataSimulateTouch = $ttContentCarousel.data("simulate-touch");
			var $autoplay = $ttContentCarousel.data("autoplay") ? {
				delay: $ttContentCarousel.data("autoplay"),
			} : $ttContentCarousel.data("autoplay");
			var $dataLoop = $ttContentCarousel.data("loop") ? {
				loopedSlides: 100,
			} : $ttContentCarousel.data("loop");

			if ($ttContentCarousel.is("[data-speed]")) {
				var $dataSpeed = $ttContentCarousel.data("speed");
			} else {
				var $dataSpeed = 900; // by default
			}

			if ($ttContentCarousel.is("[data-pagination-type]")) {
				var $dataPaginationType = $ttContentCarousel.data("pagination-type");
			} else {
				var $dataPaginationType = "bullets"; // by default (bullets/fraction/progressbar)
			}

			// Init Swiper
			// =============
			var $ttContentCarouselSwiper = new Swiper($ttContentCarousel.find(".swiper")[0], {
				// Parameters
				direction: "horizontal",
				slidesPerView: "auto",
				spaceBetween: 0,
				centeredSlides: true,
				longSwipesRatio: 0.3,
				mousewheel: false,
				keyboard: false,
				preloadImages: false, // Needed for lazy loading
				watchSlidesProgress: true, // Needed for lazy loading (if slidesPerView is "auto" or more than 1)
				preventInteractionOnTransition: false, // No actions during transition
				simulateTouch: $dataSimulateTouch,
				grabCursor: $dataSimulateTouch,
				speed: $dataSpeed,
				autoplay: $autoplay,
				loop: $dataLoop,

				lazy: {
					loadPrevNext: true,
					loadOnTransitionStart: true,
				},

				breakpoints: {
					// when window width is 1025px or larger
					1025: {
						lazy: {
							loadPrevNextAmount: 3, // Amount of next/prev slides to preload lazy images in.
						},
					}
				},

				// Navigation (arrows)
				navigation: {
					nextEl: $ttContentCarousel.find(".tt-cc-nav-next")[0],
					prevEl: $ttContentCarousel.find(".tt-cc-nav-prev")[0],
					disabledClass: "tt-cc-nav-arrow-disabled",
				},

				// Pagination
				pagination: {
					el: $ttContentCarousel.find(".tt-cc-pagination")[0],
					type: $dataPaginationType,
					modifierClass: "tt-cc-pagination-",
					dynamicBullets: true,
					dynamicMainBullets: 1,
					clickable: true,
				},

				// Events
				on: {
					lazyImageReady: (swiper) => { // Lazy load + slidesPerView:"auto" fix.
						$ttContentCarouselSwiper.update()
					},

					transitionStart: function () {

						// Play video
						$(".swiper-slide-active").find("video").each(function () {
							$(this).get(0).play();
						});

					},

					transitionEnd: function () {

						// Pause video
						$(".swiper-slide-prev").find("video").each(function () {
							$(this).get(0).pause();
						});

						$(".swiper-slide-next").find("video").each(function () {
							$(this).get(0).pause();
						});

					}
				}
			});

			// Scale down animation on carousel click
			// =======================================
			if ($ttContentCarousel.attr("data-simulate-touch") == "true") {
				if ($ttContentCarousel.hasClass("cc-scale-down")) {
					$ttContentCarousel.find(".swiper-wrapper").on("mousedown touchstart pointerdown", function (e) {
						if (e.which === 1) { // Affects the left mouse button only!
							gsap.to($ttContentCarousel.find(".tt-content-carousel-item"), {
								duration: 0.7,
								scale: 0.9
							});
						}
					});
					$("body").on("mouseup touchend pointerup mouseleave", function () {
						gsap.to($ttContentCarousel.find(".tt-content-carousel-item"), {
							duration: 0.7,
							scale: 1,
							clearProps: "scale"
						});
					});
				}
			}

		});

	}



	// =======================================================================================
	// Testimonials slider
	// Source: https://swiperjs.com/
	// =======================================================================================

	if ($(".tt-testimonials-slider").length) {
		$(".tt-testimonials-slider").each(function () {
			var $ttTestimonialsSlider = $(this);

			// Data attributes
			// ================
			var $dataSimulateTouch = $ttTestimonialsSlider.data("simulate-touch");
			var $autoplay = $ttTestimonialsSlider.data("autoplay") ? {
				delay: $ttTestimonialsSlider.data("autoplay"),
			} : $ttTestimonialsSlider.data("autoplay");
			var $dataLoop = $ttTestimonialsSlider.data("loop") ? {
				loopedSlides: 100,
			} : $ttTestimonialsSlider.data("loop");

			if ($ttTestimonialsSlider.is("[data-speed]")) {
				var $dataSpeed = $ttTestimonialsSlider.data("speed");
			} else {
				var $dataSpeed = 900; // by default
			}

			// Init Swiper
			// =============
			var $ttTestimonialsSliderSwiper = new Swiper($ttTestimonialsSlider.find(".swiper")[0], {
				// Parameters
				direction: "horizontal",
				slidesPerView: "auto",
				spaceBetween: 0,
				mousewheel: false,
				longSwipesRatio: 0.3,
				grabCursor: true,
				autoHeight: true,
				centeredSlides: true,
				preventInteractionOnTransition: false, // No actions during transition
				speed: $dataSpeed,
				simulateTouch: $dataSimulateTouch,
				autoplay: $autoplay,
				loop: $dataLoop,

				// Navigation (arrows)
				navigation: {
					nextEl: $ttTestimonialsSlider.find(".tt-ts-nav-next")[0],
					prevEl: $ttTestimonialsSlider.find(".tt-ts-nav-prev")[0],
					disabledClass: "tt-ts-nav-arrow-disabled",
				},

				// Pagination
				pagination: {
					el: $ttTestimonialsSlider.find(".tt-ts-pagination")[0],
					type: "bullets",
					modifierClass: "tt-ts-pagination-",
					dynamicBullets: true,
					dynamicMainBullets: 1,
					clickable: true,
				}
			});

			// Auto height fix
			setTimeout(function () {
				$ttTestimonialsSliderSwiper.updateAutoHeight();
			}, 100);

			// Scale down animation on slider click
			if ($ttTestimonialsSlider.hasClass("ts-scale-down")) {
				$ttTestimonialsSlider.find(".swiper-wrapper").on("mousedown touchstart pointerdown", function (e) {
					if (e.which === 1) { // Affects the left mouse button only!
						gsap.to($ttTestimonialsSlider.find(".swiper-slide"), {
							duration: 0.7,
							scale: 0.9
						});
					}
				});
				$("body").on("mouseup touchend pointerup", function () {
					gsap.to($ttTestimonialsSlider.find(".swiper-slide"), {
						duration: 0.7,
						scale: 1,
						clearProps: "scale"
					});
				});
			}
		});
	}

	// =======================================================================================
	// Img slider
	// Source: https://swiperjs.com/
	// =======================================================================================

	if ($(".slide-section").length) {
		$(".slide-section").each(function () {
			var $ttImgSlider = $(this);

			// Data attributes
			// ================
			// var $dataSimulateTouch = $ttImgSlider.data("simulate-touch");
			// var $autoplay = $ttImgSlider.data("autoplay") ? {
			// 	delay: $ttImgSlider.data("autoplay"),
			// } : $ttImgSlider.data("autoplay");
			// var $dataLoop = $ttImgSlider.data("loop") ? {
			// 	loopedSlides: 100,
			// } : $ttImgSlider.data("loop");

			// if ($ttImgSlider.is("[data-speed]")) {
			// 	var $dataSpeed = $ttImgSlider.data("speed");
			// } else {
			// 	var $dataSpeed = 900; // by default
			// }

			// Init Swiper
			// =============
			var $ttImgSliderSwiper = new Swiper($ttImgSlider.find(".swiper")[0], {
				// Parameters
				// direction: "horizontal",
				slidesPerView: 1,
				spaceBetween: 40,
				mousewheel: false,
				grabCursor: true,
				speed: 1500,
				// autoplay: ,
				// loop: $dataLoop,

				// Navigation (arrows)
				navigation: {
					nextEl: $ttImgSlider.find(".tt-ts-nav-next")[0],
					prevEl: $ttImgSlider.find(".tt-ts-nav-prev")[0],
					disabledClass: "tt-ts-nav-arrow-disabled",
				},

				// Pagination
				pagination: {
					el: $ttImgSlider.find(".tt-ts-pagination")[0],
					type: "bullets",
					modifierClass: "tt-ts-pagination-",
					dynamicBullets: true,
					dynamicMainBullets: 1,
					clickable: true,
				},
				breakpoints: {
					// When window width is 1200px or larger
					1200: {
						slidesPerView: 3,
						spaceBetween: 40
					},
					// When window width is 992px or larger
					992: {
						slidesPerView: 3,
						spaceBetween: 30
					},
					// When window width is 560px or larger
					560: {
						slidesPerView: 2,
						spaceBetween: 20
					},
					320: {
						slidesPerView: 2,
						spaceBetween: 10
					}
				},
			});

			// Auto height fix
			// setTimeout(function () {
			// 	$ttImgSliderSwiper.updateAutoHeight();
			// }, 100);

			// Scale down animation on slider click
			// if ($ttImgSlider.hasClass("ts-scale-down")) {
			// 	$ttImgSlider.find(".swiper-wrapper").on("mousedown touchstart pointerdown", function (e) {
			// 		if (e.which === 1) { // Affects the left mouse button only!
			// 			gsap.to($ttImgSlider.find(".swiper-slide"), {
			// 				duration: 0.7,
			// 				scale: 0.9
			// 			});
			// 		}
			// 	});
			// 	$("body").on("mouseup touchend pointerup", function () {
			// 		gsap.to($ttImgSlider.find(".swiper-slide"), {
			// 			duration: 0.7,
			// 			scale: 1,
			// 			clearProps: "scale"
			// 		});
			// 	});
			// }
		});
	}
	



	// ============================================================================
	// Isotope
	// More info: http://isotope.metafizzy.co
	// Note: "imagesloaded" blugin is required! https://imagesloaded.desandro.com/
	// ============================================================================

	// init Isotope
	var $container = $(".isotope-items-wrap");
	$container.imagesLoaded(function () {
		$container.isotope({
			itemSelector: ".isotope-item",
			layoutMode: "packery",
			transitionDuration: "0.7s",
			percentPosition: true
		});

		setTimeout(function () {
			$container.isotope('layout'); // Refresh Isotope
			ScrollTrigger.refresh(true); // Refresh ScrollTrigger
		}, 500);
	});

	// Filter
	$(".ttgr-cat-list > li > a").on("click", function () {
		var selector = $(this).attr("data-filter");
		$container.isotope({
			filter: selector
		});

		// Refresh ScrollTrigger
		setTimeout(function () {
			ScrollTrigger.refresh(true);
		}, 500);

		return false;
	});

	// Filter item active
	var filterItemActive = $(".ttgr-cat-list > li > a");
	filterItemActive.on("click", function () {
		var $this = $(this);
		if (!$this.hasClass("active")) {
			filterItemActive.removeClass("active");
			$this.addClass("active");
		}
	});


	// Isotope items gaps fix (uncomment the below code if isotope items gaps do not calculate correctly.)
	// ========================

	// if ($(".isotope-items-wrap").length){
	// 	// add overflow scroll to <html> (isotope items gaps fix).
	// 	if ( document.querySelector("body").offsetHeight > window.innerHeight ) {
	// 		document.documentElement.style.overflowY = "scroll";
	// 	}
	// }



	// =====================================================
	// lightGallery (lightbox plugin)
	// Source: http://sachinchoolur.github.io/lightGallery
	// Mousewheel plugin: https://github.com/jquery/jquery-mousewheel
	// =====================================================

	$(".lightgallery").lightGallery({

		// Please read about gallery options here: http://sachinchoolur.github.io/lightGallery/docs/api.html

		// lightGallery core
		selector: '.lg-trigger',
		mode: 'lg-fade', // Type of transition between images ('lg-fade' or 'lg-slide').
		height: '100%', // Height of the gallery (ex: '100%' or '300px').
		width: '100%', // Width of the gallery (ex: '100%' or '300px').
		iframeMaxWidth: '100%', // Set maximum width for iframe.
		loop: true, // If false, will disable the ability to loop back to the beginning of the gallery when on the last element.
		speed: 600, // Transition duration (in ms).
		closable: true, // Allows clicks on dimmer to close gallery.
		escKey: true, // Whether the LightGallery could be closed by pressing the "Esc" key.
		keyPress: true, // Enable keyboard navigation.
		hideBarsDelay: 3000, // Delay for hiding gallery controls (in ms).
		controls: true, // If false, prev/next buttons will not be displayed.
		mousewheel: true, // Chane slide on mousewheel.
		download: false, // Enable download button. By default download url will be taken from data-src/href attribute but it supports only for modern browsers. If you want you can provide another url for download via data-download-url.
		counter: true, // Whether to show total number of images and index number of currently displayed image.
		swipeThreshold: 50, // By setting the swipeThreshold (in px) you can set how far the user must swipe for the next/prev image.
		enableDrag: true, // Enables desktop mouse drag support.
		enableTouch: true, // Enables touch support.
		getCaptionFromTitleOrAlt: false, // Option to get captions from alt or title tags.

		// Thumbnail plugin
		thumbnail: false, // Enable thumbnails for the gallery.
		showThumbByDefault: false, // Show/hide thumbnails by default.
		thumbMargin: 5, // Spacing between each thumbnails.
		toogleThumb: true, // Whether to display thumbnail toggle button.
		enableThumbSwipe: true, // Enables thumbnail touch/swipe support for touch devices.
		exThumbImage: 'data-exthumbnail', // If you want to use external image for thumbnail, add the path of that image inside "data-" attribute and set value of this option to the name of your custom attribute.

		// Autoplay plugin
		autoplay: false, // Enable gallery autoplay.
		autoplayControls: true, // Show/hide autoplay controls.
		pause: 6000, // The time (in ms) between each auto transition.
		progressBar: true, // Enable autoplay progress bar.
		fourceAutoplay: false, // If false autoplay will be stopped after first user action

		// Full Screen plugin
		fullScreen: true, // Enable/Disable fullscreen mode.

		// Zoom plugin
		zoom: false, // Enable/Disable zoom option.
		scale: 0.5, // Value of zoom should be incremented/decremented.
		enableZoomAfter: 50, // Some css styles will be added to the images if zoom is enabled. So it might conflict if you add some custom styles to the images such as the initial transition while opening the gallery. So you can delay adding zoom related styles to the images by changing the value of enableZoomAfter.

		// Video options
		videoMaxWidth: '1400px', // Set limit for video maximal width.

		// Youtube video options
		loadYoutubeThumbnail: true, // You can automatically load thumbnails for youtube videos from youtube by setting loadYoutubeThumbnail true.
		youtubeThumbSize: 'default', // You can specify the thumbnail size by setting respective number: 0, 1, 2, 3, 'hqdefault', 'mqdefault', 'default', 'sddefault', 'maxresdefault'.
		youtubePlayerParams: { // Change youtube player parameters: https://developers.google.com/youtube/player_parameters
			modestbranding: 0,
			showinfo: 1,
			controls: 1
		},

		// Vimeo video options
		loadVimeoThumbnail: true, // You can automatically load thumbnails for vimeo videos from vimeo by setting loadYoutubeThumbnail true.
		vimeoThumbSize: 'thumbnail_medium', // Thumbnail size for vimeo videos: 'thumbnail_large' or 'thumbnail_medium' or 'thumbnail_small'.
		vimeoPlayerParams: { // Change vimeo player parameters: https://developer.vimeo.com/player/embedding#universal-parameters
			byline: 1,
			portrait: 1,
			title: 1,
			color: 'CCCCCC',
			autopause: 1
		},

		// Hash plugin (unique url for each slides)
		hash: false, // Enable/Disable hash plugin.
		hgalleryId: 1, // Unique id for each gallery. It is mandatory when you use hash plugin for multiple galleries on the same page.

		// Rotate plugin
		rotate: false,

		// Share plugin
		share: false, // Enable/Disable share plugin.
		facebook: true, // Enable Facebook share.
		facebookDropdownText: 'Facebook', // Facebok dropdown text.
		twitter: true, // Enable Twitter share.
		twitterDropdownText: 'Twitter', // Twitter dropdown text.
		googlePlus: true, // Enable Google Plus share.
		googlePlusDropdownText: 'Google+', // Google Plus dropdown text.
		pinterest: true, // Enable Pinterest share.
		pinterestDropdownText: 'Pinterest' // Pinterest dropdown text.

	});



	// ================================================================
	// Page header
	// ================================================================

	// If page header image exist
	// ===========================
	if ($(".ph-image").length) {
		$("body").addClass("ph-image-on");

		// If page header image is background image
		if ($("#page-header").hasClass("ph-bg-image")) {
			$("body").addClass("ph-bg-image-on");
		}
	}


	// If page header contains project info list
	// ==========================================
	if ($("#page-header .project-info-list").length) {
		$("#page-header").addClass("project-info-list-on");
	}


	// If "made with love" exist
	// ==========================
	if ($(".made-with-love").length) {
		$("body").addClass("made-with-love-on");
	}


	// Project share
	// ===============
	if ($(".ph-share").length) {
		$("body").addClass("ph-share-on");

		if ($(".ph-share-trigger").hasClass("ph-appear")) {
			$(".ph-share-trigger").removeClass("ph-appear");
		}
		$(".ph-share").addClass("ph-appear");

		// Project share position (move it out of page header if the window width is 1024px or smaller).
		// Expl: Since Smooth Scrollbar doesn't support element fixed position inside "scroll-container" move the "ph-share" out of it.
		function projectSharePosition() {
			if (window.matchMedia("(max-width: 768px)").matches) {
				$(".ph-share").appendTo("#body-inner");
			} else {
				$(".ph-share").appendTo("#page-header");
			}
		}
		projectSharePosition();
		$(window).resize(function () {
			projectSharePosition();
		});

		// Project share icon hover
		$(".ph-share-icon").on("mouseenter", function () {
			$(".ph-share").addClass("active");
		}).on("mouseleave", function () {
			$(".ph-share").removeClass("active");
		});

		// Prepend top close button
		$(".ph-share-content").prepend('<div class="ph-share-close-btn"><i class="fas fa-times"></i></div>');

		// Top close button hover
		$(".ph-share-close-btn").on("mouseenter", function () {
			gsap.to($ball, {
				duration: 0.3,
				scale: 0,
				opacity: 0
			});
		}).on("mouseleave", function () {
			gsap.to($ball, {
				duration: 0.3,
				scale: $ballScale,
				opacity: $ballOpacity
			});
		});

		// Open project share content
		$(".ph-share-content").appendTo("#body-inner");

		$(".ph-share-icon").on("click", function () {
			$("body").addClass("ph-share-open");
			var tl_prshIn = gsap.timeline();
			tl_prshIn.to(".ph-share-content", {
				duration: 0.4,
				autoAlpha: 1
			});
			tl_prshIn.from(".ph-share-appear", {
				duration: 0.5,
				y: 80,
				autoAlpha: 0,
				stagger: 0.1,
				ease: Power2.easeOut,
				clearProps: "all"
			}, "+=0.1");
		});

		// Close project share content
		$(".ph-share-close, .ph-share-close-btn").on("click", function () {
			$("body").removeClass("ph-share-open");
			var tl_prshOut = gsap.timeline();
			tl_prshOut.to(".ph-share-appear", {
				duration: 0.5,
				y: -80,
				autoAlpha: 0,
				stagger: 0.05,
				ease: Power2.easeIn
			});
			tl_prshOut.to(".ph-share-content", {
				duration: 0.4,
				autoAlpha: 0,
				clearProps: "all"
			}, "+=0.2");
			tl_prshOut.to(".ph-share-appear", {
				clearProps: "all"
			});
		});
	}


	// If page header background image is light (toggle class on scroll handled by scrollTrigger plugin below)
	// =========================================
	if ($("#page-header").is(".ph-bg-image.ph-bg-image-is-light")) {
		$("body").addClass("ph-bg-image-light-on");
	} else {
		$("body").removeClass("ph-bg-image-light-on");
	}

	

	

	

	



	// ================================================================
	// GSAP ScrollTrigger plugin
	// More info: https://greensock.com/docs/v3/Plugins/ScrollTrigger/
	// ================================================================

	// Page header elements scrolling effects:
	// =======================================
	if ($("#page-header").hasClass("ph-content-parallax")) {
		let tlPhParallax = gsap.timeline({
			scrollTrigger: {
				trigger: "#page-header",
				start: 'top top',
				end: 'bottom top',
				scrub: true,
				markers: false
			}
		});

		// Page header caption elements scrolling effect
		if ($(".ph-categories").length) {
			$(".ph-categories").wrapInner('<div class="ph-cat-parallax"></div>');
			tlPhParallax.to(".ph-cat-parallax", {
				y: -80
			}, 0);
		}
		if ($(".ph-caption-title").length) {
			$(".ph-caption-title").wrapInner('<div class="ph-title-parallax"></div>');
			tlPhParallax.to(".ph-title-parallax", {
				y: -40
			}, 0);
		}
		if ($(".ph-caption-subtitle").length) {
			$(".ph-caption-subtitle").wrapInner('<div class="ph-subt-parallax"></div>');
			tlPhParallax.to(".ph-subt-parallax", {
				y: -10
			}, 0);
		}
		if ($(".ph-caption-title-ghost").length) {
			$(".ph-caption-title-ghost").wrapInner('<div class="ph-ghost-parallax"></div>');
			tlPhParallax.to(".ph-ghost-parallax", {
				y: 40
			}, 0);
		}

		// Page header image scrolling effect
		if ($(".ph-image").length) {
			if ($("#page-header").hasClass("ph-bg-image")) {
				tlPhParallax.to(".ph-image-inner", {
					yPercent: 30,
					scale: 1.05
				}, 0);
			} else {
				tlPhParallax.to(".ph-image-inner", {
					yPercent: -20
				}, 0);
			}
		}

		// Page header project info list scrolling effect (effect only if it in the page header!)
		if ($("#page-header .project-info-list").length) {
			$("#page-header .project-info-list > ul > li").wrapInner('<div class="ph-pil-parallax"></div>');
			if ($("#page-header:not('.ph-center')").hasClass("ph-inline")) {
				ScrollTrigger.matchMedia({
					"(min-width: 1025px)": function () {
						gsap.to(".ph-pil-parallax", {
							y: -140,
							stagger: 0.15,
							ease: "none",
							scrollTrigger: {
								trigger: "#page-header",
								start: "top top",
								end: "bottom top",
								scrub: true,
								markers: false
							}
						});
					},

					"(max-width: 1024px)": function () {
						gsap.to("#page-header .project-info-list", {
							y: 20,
							ease: "none",
							scrollTrigger: {
								trigger: "#page-header",
								start: "top top",
								end: "bottom top",
								scrub: true,
								markers: false
							}
						});
					}
				});

			} else {

				gsap.to(".ph-pil-parallax", {
					y: 30,
					ease: "none",
					scrollTrigger: {
						trigger: "#page-header",
						start: "top top",
						end: "bottom top",
						scrub: true,
						markers: false
					}
				});
			}
		}

		// Page header scroll down circle
		if ($(".scroll-down-circle").length) {
			gsap.to(".scroll-down-circle", {
				x: -100,
				autoAlpha: 0,
				ease: "none",
				scrollTrigger: {
					trigger: "#page-header",
					start: "top top",
					end: "30% top",
					scrub: true,
					markers: false
				},
			});
		}
		if ($(".tt-scroll-down").length) {
			gsap.to(".tt-scroll-down", {
				// y: 100,
				autoAlpha: 0,
				ease: "none",
				scrollTrigger: {
					trigger: "#page-header",
					start: "top top",
					end: "30% top",
					scrub: true,
					markers: false
				},
			});
		}

		// Page header made-with-love
		if ($(".mwl-inner").length) {
			gsap.to(".mwl-inner", {
				yPercent: 250,
				autoAlpha: 0,
				ease: "none",
				scrollTrigger: {
					trigger: "#page-header",
					start: "top top",
					end: "40% top",
					scrub: true,
					markers: false
				},
			});
		}

		// Page header projekt share
		if ($(".ph-share").length) {
			$(".ph-share-trigger").wrap('<div class="ph-share-trigger-wrap"></div>');
			ScrollTrigger.matchMedia({
				"(min-width: 769px)": function () {
					gsap.to(".ph-share-trigger-wrap", {
						y: 50,
						autoAlpha: 0,
						ease: "none",
						scrollTrigger: {
							trigger: "#page-header",
							start: "top top",
							end: "30% top",
							scrub: true,
							markers: false
						},
					});
				}
			});
		}

		// If page header background image is light
		if ($("#page-header").is(".ph-bg-image.ph-bg-image-is-light")) {
			if ($("#tt-header").hasClass("tt-header-fixed")) {
				ScrollTrigger.create({
					trigger: "#page-header",
					start: "top bottom",
					end: "bottom 30px",
					scrub: true,
					markers: false,

					onLeave: () => phLeaveClass(),
					onEnter: () => phEnterClass(),
					onLeaveBack: () => phLeaveClass(),
					onEnterBack: () => phEnterClass(),
				});

				function phLeaveClass() {
					$("body").removeClass("ph-bg-image-light-on");
				};

				function phEnterClass() {
					$("body").addClass("ph-bg-image-light-on");
				};
			}
		}

	}


	// Portfolio grid categories filter show/hide on scroll
	// =====================================================
	if ($(".tt-grid-categories").length) {
		var $ttgCatTriggerWrap = $(".ttgr-cat-trigger-wrap");

		if ($ttgCatTriggerWrap.hasClass("ttgr-cat-fixed")) {
			$ttgCatTriggerWrap.appendTo("#body-inner");

			// Show/Hide trigger on page scroll
			ScrollTrigger.create({
				trigger: "#portfolio-grid",
				start: "top bottom",
				end: "bottom 75%",
				scrub: true,
				markers: false,

				onEnter: () => ttgCatShow(),
				onLeave: () => ttgCatHide(),
				onEnterBack: () => ttgCatShow(),
				onLeaveBack: () => ttgCatHide(),
			});

			function ttgCatShow() {
				gsap.to($ttgCatTriggerWrap, {
					duration: 0.4,
					autoAlpha: 1,
					scale: 1,
					ease: Power2.easeOut
				});
			}

			function ttgCatHide() {
				gsap.to($ttgCatTriggerWrap, {
					duration: 0.4,
					autoAlpha: 0,
					scale: 0.9,
					ease: Power2.easeOut
				});
			}

		} else {

			// Hide trigger before it reaches the top when page scroll
			gsap.to($ttgCatTriggerWrap, {
				yPercent: 70,
				autoAlpha: 0,
				ease: "none",
				scrollTrigger: {
					trigger: $ttgCatTriggerWrap,
					start: "top 250px",
					end: "100px 250px",
					scrub: true,
					markers: false
				},
			});

		}
	}


	// Portfolio list item info elements scrolling effects:
	// =====================================================
	$(".pli-info").each(function () {
		var $pliTitle = $(this).find(".pli-title");
		var $pliCategory = $(this).find(".pli-categories-wrap");
		var $pliCounter = $(this).find(".pli-counter");

		let tl_plIInfo = gsap.timeline({
			scrollTrigger: {
				trigger: this,
				start: "top bottom",
				markers: false
			}
		});

		if ($($pliTitle).length) {
			tl_plIInfo.from($pliTitle, {
				duration: 2.5,
				autoAlpha: 0,
				y: 80,
				ease: Expo.easeOut,
				clearProps: "all"
			}, "+=0.5");
		}
		if ($($pliCategory).length) {
			tl_plIInfo.from($pliCategory, {
				duration: 2.5,
				autoAlpha: 0,
				y: 60,
				ease: Expo.easeOut,
				clearProps: "all"
			}, "-=2.2");
		}
		if ($($pliCounter).length) {
			tl_plIInfo.from($pliCounter, {
				duration: 2.5,
				autoAlpha: 0,
				y: 40,
				ease: Expo.easeOut,
				clearProps: "all"
			}, "-=2.2");
		}
	});


	// Image parallax
	// ===============
	$(".anim-image-parallax").each(function () {

		// Add wrap <div>.
		$(this).wrap('<div class="anim-image-parallax-wrap"><div class="anim-image-parallax-inner"></div></div>');

		// Add overflow hidden.
		$(".anim-image-parallax-wrap").css({
			"overflow": "hidden"
		});

		var $animImageParallax = $(this);
		var $aipWrap = $animImageParallax.parents(".anim-image-parallax-wrap");
		var $aipInner = $aipWrap.find(".anim-image-parallax-inner");

		// Parallax
		gsap.to($animImageParallax, {
			yPercent: 30,
			ease: "none",
			scrollTrigger: {
				trigger: $aipWrap,
				start: "top bottom",
				end: "bottom top",
				scrub: true,
				markers: false,
			},
		});

		// Zoom in
		let tl_aipZoomIn = gsap.timeline({
			scrollTrigger: {
				trigger: $aipWrap,
				start: "top 90%",
				markers: false,
			}
		});
		tl_aipZoomIn.from($aipInner, {
			duration: 1.5,
			autoAlpha: 0,
			scale: 1.2,
			ease: Power2.easeOut,
			clearProps: "all"
		});

	});


	// tt-Grid "layout-creative" parallax
	// ===================================
	ScrollTrigger.matchMedia({
		"(min-width: 768px)": function () {
			$(".tt-grid.ttgr-layout-creative-1 .tt-grid-item:nth-of-type(6n+2) .ttgr-item-inner, .tt-grid.ttgr-layout-creative-1 .tt-grid-item:nth-of-type(6n+4) .ttgr-item-inner, .tt-grid.ttgr-layout-creative-2 .tt-grid-item:nth-of-type(4n+2) .ttgr-item-inner, .tt-grid.ttgr-layout-creative-2 .tt-grid-item:nth-of-type(4n+3) .ttgr-item-inner").each(function () {
				var $this = $(this);
				gsap.to($this, {
					yPercent: -50,
					ease: "none",
					scrollTrigger: {
						trigger: $this,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
						markers: false,
					},
				});
			});
		}
	});

	// Scrolling button
	// =================
	if ($(".tt-scrolling-btn").length) {
		$(".tt-scrolling-btn").each(function () {
			var $this = $(this);
			var $scrBtnSvg = $this.find(".scr-btn-spinner");
			gsap.from($scrBtnSvg, {
				rotate: 240,
				ease: "none",
				scrollTrigger: {
					trigger: $scrBtnSvg,
					start: "-40% bottom",
					end: "120% top",
					scrub: true,
					markers: false,
				},
			});
		});
	}


	// Appear on scroll
	// =================

	// zoom in
	$(".anim-zoomin").each(function () {

		// Add wrap <div>.
		$(this).wrap('<div class="anim-zoomin-wrap"></div>');

		// Add overflow hidden.
		$(".anim-zoomin-wrap").css({
			"overflow": "hidden"
		})

		var $this = $(this);
		var $asiWrap = $this.parents(".anim-zoomin-wrap");

		let tl_ZoomIn = gsap.timeline({
			scrollTrigger: {
				trigger: $asiWrap,
				start: "top 90%",
				markers: false,
				onEnter: () => animZoomInRefresh(),
			}
		});
		tl_ZoomIn.from($this, {
			duration: 1.5,
			autoAlpha: 0,
			scale: 1.2,
			ease: Power2.easeOut,
			clearProps: "all"
		});

		// Refresh start/end positions on enter.
		function animZoomInRefresh() {
			ScrollTrigger.refresh();
		};
	});


	// fade in-up
	$(".anim-fadeinup").each(function () {
		let tl_FadeInUp = gsap.timeline({
			scrollTrigger: {
				trigger: this,
				start: "top bottom",
				markers: false
			}
		});

		tl_FadeInUp.from(this, {
			duration: 2.5,
			autoAlpha: 0,
			y: 100,
			ease: Expo.easeOut,
			clearProps: "all"
		}, "+=0.3");
	});


	// skew in-up
	$(".anim-skewinup").each(function () {
		let tl_SkewInUp = gsap.timeline({
			scrollTrigger: {
				trigger: this,
				start: "top bottom",
				markers: false
			}
		});

		tl_SkewInUp.from(this, {
			duration: 2,
			skewY: 5,
			transformOrigin: "left top",
			autoAlpha: 0,
			y: 100,
			ease: Expo.easeOut,
			clearProps: "all"
		}, "+=0.3");
	});


	// stretch in-up
	$(".anim-stretchinup").each(function () {
		let tl_StretchInUp = gsap.timeline({
			scrollTrigger: {
				trigger: this,
				start: "top bottom",
				markers: false
			}
		});

		tl_StretchInUp.from(this, {
			duration: 2,
			autoAlpha: 0,
			y: 100,
			scaleY: 1.4,
			transformOrigin: "top",
			ease: Expo.easeOut,
			clearProps: "all"
		}, "+=0.2");
	});



	// ================================================================
	// Portfolio list
	// ================================================================

	// Play video on hover
	$(".pli-image-link").on("mouseenter", function () {
		$(this).find("video").each(function () {
			$(this).get(0).play();
		});
	}).on("mouseleave", function () {
		$(this).find("video").each(function () {
			$(this).get(0).pause();
		});
	});

	// Item image zoom on hover
	$(".portfolio-list-item").each(function () {
		if ($(".portfolio-list").hasClass("pli-hover")) {
			$(this).find(".pli-image img").wrap('<div class="pli-image-hover-zoom"></div>');
		}
	});



	// ================================================================
	// Portfolio interactive
	// ================================================================

	if (!isMobile) { // No effect on mobile devices!

		if ($(".portfolio-interactive").hasClass("pi-force-scroll")) {

			// Clone hover title (no effect on mobile devices!).
			$(".pi-item-hover-title").each(function () {
				var $this = $(this);
				$this.wrapInner('<span></span>');

				// Clone hover title
				var $piHoverTitle = $($this).find("span");
				for (var i = 0; i < 5; i++) {
					$piHoverTitle.clone().insertAfter($piHoverTitle);
				}
			});

		} else {

			// If the hover title is wider than the parent element.
			$(".pi-item-hover-title").each(function () {
				var $this = $(this);
				if ($this.width() > $this.parent().width()) {
					$this.wrapInner('<span></span>');

					// Clone hover title
					var $pnHoverTitle = $($this).find("span");
					for (var i = 0; i < 1; i++) {
						$pnHoverTitle.clone().insertAfter($pnHoverTitle);
					}
				}
			});
		}

		// Title on link hover.
		$(".portfolio-interactive-item").each(function () {
			$(this).find(".pi-item-title-link").on("mouseenter", function () {
				$(this).parent().addClass("pi-item-hover");
			}).on("mouseleave", function () {
				$(this).parent().removeClass("pi-item-hover");
			});
		});

		// Hover scrolling speed.
		$(".portfolio-interactive-item").each(function () {
			var $piHoverSpeed = $(this).data("scroll-speed");
			$(this).find(".pi-item-hover-title span").css({
				"animation-duration": $piHoverSpeed + "s",
			});
		});

	}



	// ================================================================
	// Portfolio grid
	// ================================================================

	// If "pgi-cap-inside enabled
	// ===========================
	if ($("#portfolio-grid").hasClass("pgi-cap-inside")) {

		// Move "pgi-caption" to inside "pgi-image-wrap".
		$(".portfolio-grid-item").each(function () {
			$(this).find(".pgi-caption").appendTo($(this).find(".pgi-image-wrap"));
		});

		// Remove grid item title anchor tag if exist.
		if ($(".pgi-title a").length) {
			$(".pgi-title a").contents().unwrap();
		}
	}


	// Play video on hover
	// ====================
	$(".pgi-image-wrap").on("mouseenter", function () {
		$(this).find("video").each(function () {
			$(this).get(0).play();
		});
	}).on("mouseleave", function () {
		$(this).find("video").each(function () {
			$(this).get(0).pause();
		});
	});


	// Portfolio grid categories filter
	// =================================
	$(".ttgr-cat-nav").appendTo("#body-inner");

	// On category trigger click.
	$(".ttgr-cat-trigger").on("click", function () {
		$("body").addClass("ttgr-cat-nav-open");
		if ($("body").hasClass("ttgr-cat-nav-open")) {

			gsap.to(".portfolio-grid-item", {
				duration: 0.3,
				scale: 0.9
			});
			gsap.to(".pgi-caption, .ttgr-cat-trigger", {
				duration: 0.3,
				autoAlpha: 0
			});

			// Make "ttgr-cat-nav" unclickable.
			$(".ttgr-cat-nav").off("click");

			// Catecories step in animations.
			var tl_ttgrIn = gsap.timeline({
				// Wait until the timeline is completed then make "ttgr-cat-nav" clickable again.
				onComplete: function () {
					ttCatNavClose();
				}
			});
			tl_ttgrIn.to(".ttgr-cat-nav", {
				duration: 0.3,
				autoAlpha: 1
			});
			tl_ttgrIn.from(".ttgr-cat-list > li", {
				duration: 0.3,
				y: 80,
				autoAlpha: 0,
				stagger: 0.05,
				ease: Power2.easeOut,
				clearProps: "all"
			});

			// On catecory link click
			$(".ttgr-cat-nav a")
				.not('[target="_blank"]') // omit from selection
				.not('[href^="#"]') // omit from selection
				.not('[href^="mailto"]') // omit from selection
				.not('[href^="tel"]') // omit from selection
				.on('click', function () {
					gsap.to(".ttgr-cat-list > li", {
						duration: 0.3,
						y: -80,
						autoAlpha: 0,
						stagger: 0.05,
						ease: Power2.easeIn
					});
				});
		}
	});

	// On close click function
	function ttCatNavClose() {
		$(".ttgr-cat-nav").on("click", function () {
			$("body").removeClass("ttgr-cat-nav-open");

			// Catecories step out animations
			var tl_ttgrClose = gsap.timeline();
			tl_ttgrClose.to(".ttgr-cat-list > li", {
				duration: 0.3,
				y: -80,
				autoAlpha: 0,
				stagger: 0.05,
				ease: Power2.easeIn
			});
			tl_ttgrClose.to(".ttgr-cat-nav", {
				duration: 0.3,
				autoAlpha: 0,
				clearProps: "all"
			}, "+=0.2");
			tl_ttgrClose.to(".portfolio-grid-item", {
				duration: 0.3,
				scale: 1,
				clearProps: "all"
			}, "-=0.4");
			tl_ttgrClose.to(".pgi-caption, #page-header, .ttgr-cat-trigger", {
				duration: 0.3,
				autoAlpha: 1,
				clearProps: "all"
			}, "-=0.4");
			tl_ttgrClose.to(".ttgr-cat-list > li", {
				clearProps: "all"
			}); // clearProps only
		});
	}



	// ================================================================
	// tt-Gallery
	// ================================================================

	// Play video on hover
	$(".tt-gallery-video-wrap").on("mouseenter", function () {
		$(this).find("video").each(function () {
			$(this).get(0).play();
		});
	}).on("mouseleave", function () {
		$(this).find("video").each(function () {
			$(this).get(0).pause();
		});
	});

	// Gallery item image zoom on hover
	$(".tt-gallery-item").each(function () {
		if ($(".tt-gallery").hasClass("ttga-hover")) {
			$(this).find(".tt-gallery-image img").wrap('<div class="tt-gallery-image-hover-zoom"></div>');
		}
	});



	// ================================================================
	// tt-Accordion
	// ================================================================

	$(".tt-accordion").each(function () {

		// If accordion content has class "is-open"
		$(this).find(".tt-accordion-item").each(function () {
			var $this = $(this);

			if ($this.find(".tt-accordion-content").hasClass("is-open")) {
				$this.addClass("active");
			}
		});

		// Accordion item on click
		$(this).find(".tt-accordion-heading").on("click", function () {
			var $this = $(this);

			if ($this.parents(".tt-accordion-item").hasClass("active")) {
				$this.parents(".tt-accordion-item").removeClass("active");
				$this.next(".tt-accordion-content").slideUp(350);
			} else {
				$this.parent().parent().find(".tt-accordion-item").removeClass("active");
				$this.parent().parent().find(".tt-accordion-content").slideUp(350);
				$this.parents(".tt-accordion-item").toggleClass("active");
				$this.next(".tt-accordion-content").slideToggle(350);
			}
			return false;
		});
	});



	// =======================================================================================
	// tt-Tabs
	// =======================================================================================

	$(".tt-tabs").each(function () {
		$(this).find(".tt-tab-btn").on("click", function () {

			// Active/deactivate tab buttons
			var $ttTabButton = $(this);
			var $ttTabs = $ttTabButton.parents(".tt-tabs");

			$ttTabs.find(".tt-tab-btn").removeClass("active");
			$ttTabButton.addClass("active");

			// Show/hide tab content
			var $ttTabName = $ttTabButton.attr("data-content-id");

			$ttTabs.find(".tt-tab-content").removeClass("active");
			$ttTabs.find(".tt-tab-content-wrap #" + $ttTabName).addClass("active");

		});
	});



	// ================================================================
	// Page nav
	// ================================================================

	if (!isMobile) { // No effect on mobile devices!

		if ($(".tt-page-nav").hasClass("tt-pn-scroll")) {

			$(".tt-page-nav").find(".tt-pn-hover-title").each(function () {
				var $this = $(this);
				$this.wrapInner('<span></span>');

				// Clone hover title
				var $pnHoverTitle = $($this).find("span");
				for (var i = 0; i < 7; i++) {
					$pnHoverTitle.clone().insertAfter($pnHoverTitle);
				}
			});

		} else {

			// If the hover title is wider than the parent element.
			$(".tt-page-nav").find(".tt-pn-hover-title").each(function () {
				var $this = $(this);
				if ($this.width() > $this.parent().width()) {
					$this.wrapInner('<span></span>');

					// Clone hover title
					var $pnHoverTitle = $($this).find("span");
					for (var i = 0; i < 7; i++) {
						$pnHoverTitle.clone().insertAfter($pnHoverTitle);
					}
				}
			});
		}

	}



	// ==================================
	// Sidebar (classic)
	// ==================================

	// If tt-sidebar exist.
	if ($(".tt-sidebar").length) {

		$("body").addClass("tt-sidebar-on");

		// If tt-sidebar has class "sidebar-left" add class "sidebar-left-on" to <pody>.
		if ($(".tt-sidebar").hasClass("sidebar-left")) {
			$("body").addClass("tt-sidebar-left-on");
		}

		// If tt-sidebar has class "sidebar-right" add class "sidebar-right-on" to <pody>.
		if ($(".tt-sidebar").hasClass("sidebar-right")) {
			$("body").addClass("tt-sidebar-right-on");
		}


		// Sidebar for small screen
		// =========================

		// Wrap sidebar.
		$(".tt-sidebar").wrap('<div class="tt-sidebar-holder"><div class="tt-sidebar-wrap"></div></div>');

		// Append sidebar cover and trigger
		$(".tt-sidebar-wrap").append('<div class="tt-sidebar-cover"></div> <div class="tt-sidebar-trigger"><span class="tt-str-icon"><i class="fas fa-align-justify"></i></span><span class="tt-str-icon-close"><i class="fas fa-times"></i></span></div>');

		// Prepend sidebar top close button.
		$(".tt-sidebar").prepend('<div class="tt-sidebar-close-btn"><i class="fas fa-times"></i></div>');

		// Move sidebar trigger into "header-tools-dynamic" if window width is 768px or smaller.
		if ($(".tt-header-tools-dynamic").length) {
			function ttMoveSidebarTriggerToHtd() {
				if (window.matchMedia("(max-width: 768px)").matches) {
					if ($(".to-shop-list-btn-wrap").length) {
						$(".tt-sidebar-trigger").insertAfter(".to-shop-list-btn-wrap");
					} else {
						$(".tt-sidebar-trigger").prependTo(".tt-header-tools-dynamic");
					}
				} else {
					$(".tt-sidebar-trigger").appendTo(".tt-sidebar-wrap");
				}
			}
			ttMoveSidebarTriggerToHtd();
			$(window).resize(function () {
				ttMoveSidebarTriggerToHtd();
			});
		}

		// Move sidebar trigger into "ph-share" if window width is 768px or smaller.
		if ($(".ph-share").length) {
			function ttMoveSidebarTriggerToPhShare() {
				if (window.matchMedia("(max-width: 768px)").matches) {
					$(".tt-sidebar-trigger").prependTo(".ph-share");
				} else {
					$(".tt-sidebar-trigger").appendTo(".tt-sidebar-wrap");
				}
			}
			ttMoveSidebarTriggerToPhShare();
			$(window).resize(function () {
				ttMoveSidebarTriggerToPhShare();
			});
		}

		// Append sidebar if the window width is 991px or smaller.
		function ttSidebarPosition() {
			if (window.matchMedia("(max-width: 991px)").matches) {
				$(".tt-sidebar-wrap").appendTo("#body-inner");
			} else {
				$(".tt-sidebar-wrap").prependTo(".tt-sidebar-holder");
			}
		}
		ttSidebarPosition();
		$(window).resize(function () {
			ttSidebarPosition();
		});

		// Open/close sidebar.
		$(".tt-sidebar-trigger").on("click", function () {
			$("body").toggleClass("tt-sidebar-open");
		});
		$(".tt-sidebar-close-btn, .tt-sidebar-cover").on("click", function () {
			$("body").removeClass("tt-sidebar-open");
		});
	}



	// ==================================
	// Sliding sidebar
	// ==================================

	// If sliding sidebar exist.
	if ($(".tt-sliding-sidebar-wrap").length) {

		$("body").addClass("tt-sliding-sidebar-on, tt-sliding-sidebar-left-on"); // left position is by default.

		// Append sliding sidebar.
		$(".tt-sliding-sidebar-wrap").appendTo("#body-inner");

		// Prepend top close button.
		$(".tt-sliding-sidebar").prepend('<div class="tt-sliding-sidebar-close-btn"><i class="fas fa-times"></i></div>');

		// Top close button hover
		$(".tt-sliding-sidebar-close-btn").on("mouseenter", function () {
			gsap.to($ball, {
				duration: 0.3,
				scale: 0,
				opacity: 0
			});
		}).on("mouseleave", function () {
			gsap.to($ball, {
				duration: 0.3,
				scale: $ballScale,
				opacity: $ballOpacity
			});
		});

		// Move sliding sidebar trigger into "header-tools-dynamic" if window width is 768px or smaller.
		if ($(".tt-header-tools-dynamic").length) {
			function ttMoveSlidingSidebarTriggerToHtd() {
				if (window.matchMedia("(max-width: 768px)").matches) {
					if ($(".to-shop-list-btn-wrap").length) {
						$(".tt-sliding-sidebar-trigger").insertAfter(".to-shop-list-btn-wrap");
					} else {
						$(".tt-sliding-sidebar-trigger").prependTo(".tt-header-tools-dynamic");
					}
				} else {
					$(".tt-sliding-sidebar-trigger").appendTo(".tt-sidebar-wrap");
				}
			}
			ttMoveSlidingSidebarTriggerToHtd();
			$(window).resize(function () {
				ttMoveSlidingSidebarTriggerToHtd();
			});
		}

		// Move sliding sidebar trigger into "ph-share" if window width is 768px or smaller.
		if ($(".ph-share").length) {
			function ttMoveSidebarTriggerToPhShare() {
				if (window.matchMedia("(max-width: 768px)").matches) {
					$(".tt-sliding-sidebar-trigger").prependTo(".ph-share");
				} else {
					$(".tt-sliding-sidebar-trigger").appendTo(".tt-sliding-sidebar-wrap");
				}
			}
			ttMoveSidebarTriggerToPhShare();
			$(window).resize(function () {
				ttMoveSidebarTriggerToPhShare();
			});
		}

		// Open/close sliding sidebar.
		$(".tt-sliding-sidebar-trigger").on("click", function () {
			$("body").toggleClass("tt-sliding-sidebar-open");
		});
		$(".tt-sliding-sidebar-close, .tt-sliding-sidebar-close-btn").on("click", function () {
			$("body").removeClass("tt-sliding-sidebar-open");
		});

		// If sliding sidebar has class "tt-ss-right" add class "tt-ss-right-on" to <pody>.
		if ($(".tt-sliding-sidebar-wrap").hasClass("tt-ss-right")) {
			$("body").removeClass("tt-sliding-sidebar-left-on");
			$("body").addClass("tt-sliding-sidebar-right-on");
		}
	}



	// ==================================
	// Scrolling text
	// ==================================

	// Hover scrolling speed.
	$(".tt-scrolling-text").each(function () {
		var $tt_stSpeed = $(this).data("scroll-speed");
		$(this).find(".tt-scrolling-text-inner").css({
			"animation-duration": $tt_stSpeed + "s",
		});
	});



	// ================================================================
	// Scroll between anchors
	// Requires "Smooth Scrollbar" (https://github.com/idiotWu/smooth-scrollbar/blob/develop/docs/api.md#scrollbarscrollintoview)
	// ================================================================

	$('a[href^="#"]')
		.not('[href$="#"]') // omit from selection
		.not('[href$="#0"]') // omit from selection
		.on("click", function () {

			var target = this.hash;

			// If fixed header position enabled.
			if ($("#tt-header").hasClass("tt-header-fixed")) {
				var $offset = $("#tt-header").height();
			} else {
				var $offset = 0;
			}

			// You can use data attribute (for example: data-offset="100") to set top offset in HTML markup if needed.
			if ($(this).data("offset") != undefined) $offset = $(this).data("offset");

			if (!isMobile) { // Not for mobile devices!
				if ($("body").hasClass("tt-smooth-scroll")) {
					var topY = $(target).offset().top - $("#scroll-container > .scroll-content").offset().top - $offset;
					var $scrollbar = Scrollbar.init(document.getElementById("scroll-container"));
					gsap.to($scrollbar, {
						duration: 1.5,
						scrollTo: {
							y: topY,
							autoKill: true
						},
						ease: Expo.easeInOut
					});

				} else {
					var topY = $(target).offset().top - $("body").offset().top - $offset;
					$("html,body").animate({
						scrollTop: topY
					}, 800);
				}
			} else {
				var topY = $(target).offset().top - $("body").offset().top - $offset;
				$("html,body").animate({
					scrollTop: topY
				}, 800);
			}
			return false;
		});



	// ================================================================
	// Scroll to top
	// Requires "GSAP ScrollToPlugin" (https://greensock.com/docs/v2/Plugins/ScrollToPlugin)
	// ================================================================

	$(".scroll-to-top").on("click", function () {
		if (!isMobile) { // Not for mobile devices!
			if ($("body").hasClass("tt-smooth-scroll")) {
				var $scrollbar = Scrollbar.init(document.getElementById("scroll-container"));
				gsap.to($scrollbar, {
					duration: 1.5,
					scrollTo: {
						y: 0,
						autoKill: true
					},
					ease: Expo.easeInOut
				});
			} else {
				$("html,body").animate({
					scrollTop: 0
				}, 800);
			}
		} else {
			$("html,body").animate({
				scrollTop: 0
			}, 800);
		}
		return false;
	});



	// =======================================================================================
	// Defer videos (Youtube, Vimeo)
	// Note: When you have embed videos in your webpages it causes your page to load slower.
	// Deffering will allow your page to load quickly.
	// Source: https://www.feedthebot.com/pagespeed/defer-videos.html
	// =======================================================================================

	function init() {
		var vidDefer = document.getElementsByTagName("iframe");
		for (var i = 0; i < vidDefer.length; i++) {
			if (vidDefer[i].getAttribute("data-src")) {
				vidDefer[i].setAttribute("src", vidDefer[i].getAttribute("data-src"));
			}
		}
	}
	window.onload = init;



	// ================================================================
	// Forms
	// ================================================================

	// Remove input placeholder on focus
	$("input,textarea").focus(function () {
		$(this).data("placeholder", $(this).attr("placeholder")).attr("placeholder", "");
	}).blur(function () {
		$(this).attr("placeholder", $(this).data("placeholder"));
	});

	// Form "Browse File" button info
	$(document).on("change", ":file", function () {
		var input = $(this),
			numFiles = input.get(0).files ? input.get(0).files.length : 1,
			label = input.val().replace(/\\/g, "/").replace(/.*\//, "");
		input.trigger("fileselect", [numFiles, label]);
	});
	$(":file").on("fileselect", function (event, numFiles, label) {
		var input = $(this).parents(".tt-form-file").find(".tt-file-info"),
			log = numFiles > 1 ? numFiles + " files selected" : label;

		if (input.length) {
			input.val(log);
		} else {
			if (log) alert(log);
		}
	});



	// ========================================
	// Universal PHP Mail Feedback Script
	// (https://github.com/agragregra/uniMail)
	// ========================================

	// E-mail Ajax Send
	$("#tt-contact-form").submit(function () { // Change (your contact form ID)
		var th = $(this);
		$.ajax({
			type: "POST",
			url: "mail.php", // Change (mail.php path)
			data: th.serialize()
		}).done(function () {
			alert("Thank you. Your message has been sent!");
			setTimeout(function () {
				// Done Functions
				th.trigger("reset");
			}, 800);
		});
		return false;
	});



	// ================================================================
	// Miscellaneous
	// ================================================================

	// tt-Button disabled (prevent click)
	// ===================
	$(".tt-btn-disabled").find("a").on("click", function () {
		return false;
	});


	// Force page scroll position to top on refresh (do not remove!)
	// =============================================
	$(window).on("pagehide", function () {
		$(window).scrollTop(0);
	});


	// Hover fix for iOS
	// ==================
	$("*").on("touchstart", function () {
		$(this).trigger("hover");
	}).on("touchend", function () {
		$(this).trigger("hover");
	});



	// ================================================================
	// Begin demo button (for DEMO SITE ONLY!!!)
	// Note: GSAP and ScrollTrigger plugin required!
	// ================================================================

	// Append button
	// var $tt_demo_btn = '<a href="https://1.envato.market/tank" class="tt-demo-btn" target="_blank" rel="noopener"><div class="tt-demo-btn-img"><img src="https://stuff.themetorium.net/img/envato-logo-white.png" alt="Download!"></div><div class="tt-demo-btn-text">Buy This<br> Template!</div></a>';

	// $("#body-inner").append($tt_demo_btn);


	// Activate button on menu trigger click (classic menu mobile trigger and overlay menu trigger)
	$(".tt-ol-menu-toggle-btn-text, .tt-ol-menu-toggle-btn, .tt-m-menu-toggle-btn-text, .tt-m-menu-toggle-btn").on("click", function () {
		$("body").toggleClass("tt-demo-btn-active");
		if ($("body").hasClass("tt-demo-btn-active")) {
			gsap.to(".tt-demo-btn", {
				duration: 0.3,
				scale: 1,
				autoAlpha: 1,
				delay: 0.8
			});
		} else {
			gsap.to(".tt-demo-btn", {
				duration: 0.3,
				scale: 0.9,
				autoAlpha: 0
			});
		}
	});

	// On menu link click (classic menu and overlay menu)
	$(".tt-overlay-menu a, .tt-main-menu-list a, .tt-logo a")
		.not('[target="_blank"]') // omit from selection
		.not('[href^="#"]') // omit from selection
		.not('[href^="mailto"]') // omit from selection
		.not('[href^="tel"]') // omit from selection
		.on('click', function () {
			gsap.to(".tt-demo-btn", {
				duration: 0.3,
				scale: 0.9,
				autoAlpha: 0
			});
		});

	// CSS
	var $css_demo_btn = {
		"position": "fixed",
		"display": "flex",
		"align-items": "center",
		"right": "15px",
		"bottom": "15px",
		"background": "#6ca12b",
		"color": "#fff",
		"z-index": "99999",
		"overflow": "hidden",
		"opacity": "0",
		"visibility": "hidden",
		"transform": "scale(0.9)",
		"border-radius": "100px",
	}
	var $css_demo_btn_img = {
		"width": "60px",
		"height": "60px",
		"padding": "18px",
	}
	var $css_demo_btn_text = {
		"width": "0",
		"overflow": "hidden",
		"white-space": "nowrap",
		"font-size": "15px",
		"line-height": "1.3",
		"color": "#FFF",
		"opacity": "0",
		"visibility": "hidden",
	}

	$(".tt-demo-btn").css($css_demo_btn);
	$(".tt-demo-btn-img").css($css_demo_btn_img);
	$(".tt-demo-btn-text").css($css_demo_btn_text);

	// Button hover
	$(".tt-demo-btn").on("mouseenter", function () {
		gsap.to(".tt-demo-btn-text", {
			duration: 0.3,
			width: "110px",
			autoAlpha: 1
		});
		gsap.to($ball, {
			duration: 0.3,
			scale: 0,
			opacity: 0
		});
	}).on("mouseleave", function () {
		gsap.to(".tt-demo-btn-text", {
			duration: 0.3,
			width: "0",
			autoAlpha: 0,
			clearProps: "autoAlpha, width"
		});
		gsap.to($ball, {
			duration: 0.3,
			scale: $ballScale,
			opacity: $ballOpacity
		});
	});

	// ================================================================
	// End demo button (for DEMO SITE ONLY!!!)
    // Marquee3k.init();

	// function load_collection_tag_filter() {
	// 	/* Product Tag Filters - Good for any number of filters on any type of collection pages */
	// 	var collFilters = jQuery('.coll-filter');
	// 	collFilters.change(function () {
	// 		var newTags = [];
	// 		collFilters.each(function () {
	// 			var val = jQuery(this).val();
	// 			if (val) {
	// 				newTags.push(val);
	// 			}
	// 		});
	// 		if (newTags.length) {
	// 			var query = newTags.join('+');
	// 			var link = $('#link-to-tag-generic').val();
	// 			window.location.href = $('#link-to-tag-generic a').attr('href').replace('tag', query);
	// 		} else {
	// 			window.location.href = $('#link-to-collection').val();
	// 		}
	// 	});
	
	// 	$(".coll-filter").selectOrDie({
	// 		customClass: "custom",
	// 		customID:    "custom",
	// 		size: 10
	// 	});
	// }
	
	// function load_collection_sort() {
	// 	Shopify.queryParams = {};
	// 	if (location.search.length) {
	// 		for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
	// 			aKeyValue = aCouples[i].split('=');
	// 			if (aKeyValue.length > 1) {
	// 				Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
	// 			}
	// 		}
	// 	}
	
	// 	var sort_by = $('#collection-sort-by').val();
	// 	jQuery('#sort-by')
	// 		.val(sort_by)
	// 		.bind('change', function() {
	// 			Shopify.queryParams.sort_by = jQuery(this).val();
	// 			location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
	// 		});
	
	// 	$("#sort-by").selectOrDie({
	// 		customClass: "custom",
	// 		customID:    "custom"
	// 	});
	// }
	
	// function load_collection_mobile_sidebar() {
	// 	$('.collection-sidebar--section h2').on('click', function () {
	// 		var $this = $(this);
	// 		var parent = $this.parent();
	// 		parent.toggleClass('expanded');
	// 	});
	// }

	// function block_select(event) {
	// 	// Stop animation and show block when selected in the Slideshow section
	// 	var slider = sliders[event.detail.sectionId];
	// 	if (slider) {
	// 		var index = parseInt(event.target.dataset.slideIndex);
	// 		slider.show_slide(index);
	// 	}
	
	// 	// Stop animation and show block when select in Text Adverts section on mobile
	// 	var mobile_text_advert = $(event.target).parents('.homepage-sections-wrapper').find('.mobile-homepage-text-adverts');
	// 	if (mobile_text_advert.length > 0) {
	// 		var index = Array.prototype.indexOf.call(event.target.parentElement.children, event.target);
	// 		mobile_text_advert.flexslider("stop");
	// 		mobile_text_advert.flexslider(index);
	// 	}
	
	// }
	
	// function block_deselect(event) {
	// 	// Resume animation when block is deselected in the Slideshow section
	// 	var slider = sliders[event.detail.sectionId];
	// 	if (slider) {
	// 		slider.start_animation();
	// 	}
	
	// 	// Resume animation when block is deselected in Text Adverts section on mobile
	// 	var mobile_text_advert = $(event.target).parents('.homepage-sections-wrapper').find('.mobile-homepage-text-adverts');
	// 	if (mobile_text_advert.length > 0) {
	// 		mobile_text_advert.flexslider("play");
	// 	}
	// }
	
	// function get_section_name(event) {
	// 	var section = null;
	// 	if (event && event.detail) {
	// 		var data = {};
	// 		var dataset = event.target.dataset;
	// 		for (var key in dataset) {
	// 			if (dataset.hasOwnProperty(key) && key.indexOf('themeEditorSection-') === 0) {
	// 				data = JSON.parse(dataset[key]);
	// 			}
	// 		}
	// 		if (data.hasOwnProperty('type')) {
	// 			section = data['type'];
	// 		}
	// 	}
	// 	return section;
	// }
	// function onload(event) {
	// 	document.addEventListener('shopify:block:select', block_select);
    // 	document.addEventListener('shopify:block:deselect', block_deselect);
	// 	var section = get_section_name(event);
	// 	if (!section || section === 'collection-template') {
	// 		load_collection_tag_filter();
	// 		load_collection_sort();
	// 		load_collection_mobile_sidebar();
	// 	}
	// }

	// function onunload() {
	// 	document.removeEventListener('shopify:block:select', block_select);
	// 	document.removeEventListener('shopify:block:deselect', block_deselect);
	// 	sliders = {};
	// }
	
	// document.addEventListener('shopify:section:load', onload);
	// document.addEventListener('shopify:section:unload', onunload);
	// document.addEventListener("DOMContentLoaded", onload);
	$('.count-number-item .number').countUp({
        delay: 10,
        time: 1500
    });


})(jQuery);